// page-hatena-content.jsx — 研修事業部「デジタル経理人材プログラム」LP (issue#24 #15-17/#30-36 まで反映済)
// issue #24 / 世戸口プレビュー(training-preview.html)準拠。miyazawa.css + ページ固有CSSを内包し
// プレビューのマークアップを忠実に再現。reveal/ヘッダー追従/スムーススクロール/モバイルメニューはReactで付与。

(function(){
  const ASSETS = (window.HB_ASSETS||'') + 'images/academy/';
  const CSS = `/* ==========================================================================
   HatenaBase HP — Miyazawa Design System (extracted from VariantDPC)
   ========================================================================== */

@import url('https://fonts.googleapis.com/css2?family=Zen+Kaku+Gothic+New:wght@300;400;500;700;900&family=Noto+Sans+JP:wght@400;500;700;900&display=swap');

/* ====== Reset & Base ====== */
html, body { margin:0; padding:0; background:#FFFFFF; font-family:"Zen Kaku Gothic New","Noto Sans JP",-apple-system,sans-serif; color:#0A2846; letter-spacing:.02em; overflow-x:hidden; }
* { box-sizing:border-box; }
img { max-width:100%; display:block; }
a { color:inherit; text-decoration:none; }

/* ====== CSS Variables ====== */
:root {
  --hb-blue: #0F4FB8;
  --hb-blue-light: #5C8FDB;
  --hb-blue-ghost: #F4F8FD;
  --hb-ink: #0A0A0A;
  --hb-paper: #FAFAFA;
  --hb-border: #E0E4E8;
  --hb-muted: #8A8A93;
  --hb-sub: #3A3A45;
}

/* ====== Reveal Animations ====== */
@keyframes hb-fade { to { opacity:1; } }

.hb-chars { display:inline; }
.hb-chars .hb-line { display:block; overflow:hidden; padding-bottom:.22em; }
.hb-chars .hb-c {
  display:inline-block; opacity:0; transform: translateY(105%);
  transition: opacity .55s cubic-bezier(.16,.88,.2,1), transform .55s cubic-bezier(.16,.88,.2,1);
}
.hb-chars.is-in .hb-c { opacity:1; transform:translateY(0); }

.hb-up { opacity:0; transform: translateY(28px); transition: opacity .6s cubic-bezier(.16,.88,.2,1), transform .6s cubic-bezier(.16,.88,.2,1); }
.hb-up.is-in { opacity:1; transform: translateY(0); }

@media (prefers-reduced-motion: reduce) {
  .hb-chars .hb-c, .hb-up { opacity:1 !important; transform:none !important; transition:none !important; }
}

/* ====== Header ====== */
.hb-header {
  position: sticky; top: 0; z-index: 40;
  height: 72px; background: rgba(255,255,255,0.94);
  backdrop-filter: blur(10px);
  border-bottom: 1px solid var(--hb-border);
  display: flex; align-items: center; justify-content: space-between;
  padding: 0 28px;
}
.hb-header-logo { display: block; }
.hb-header-logo img { height: 28px; display: block; }

.hb-pc-nav {
  display: flex; gap: 30px; align-items: center;
}
.hb-nav-item {
  background: none; border: none; padding: 8px 0; cursor: pointer;
  color: var(--hb-ink); text-align: left;
  display: flex; flex-direction: column; gap: 2px;
  position: relative; text-decoration: none;
}
.hb-nav-item.active { color: var(--hb-blue); }
.hb-nav-en { font-family: "Zen Kaku Gothic New", "Hiragino Kaku Gothic ProN", "Noto Sans JP", sans-serif; font-size: 11px; font-weight: 500; letter-spacing: 0.06em; }
.hb-nav-jp { font-family: "Zen Kaku Gothic New", "Noto Sans JP", sans-serif; font-size: 10.5px; font-weight: 500; color: var(--hb-muted); }
.hb-nav-item.active .hb-nav-jp { color: var(--hb-blue); }
.hb-nav-underline {
  position: absolute; left: 0; right: 0; bottom: -1px;
  height: 2px; background: var(--hb-blue);
  transform: scaleX(0); transform-origin: left center;
  transition: transform .35s cubic-bezier(.16,.88,.2,1);
}
.hb-nav-item:hover .hb-nav-underline,
.hb-nav-item.active .hb-nav-underline { transform: scaleX(1); }

.hb-nav-divider { width: 1px; height: 18px; background: var(--hb-border); }

.hb-contact-btn {
  display: inline-flex; align-items: center; gap: 8px;
  padding: 10px 18px; background: #0A2846; color: #fff;
  font-family: "Zen Kaku Gothic New", "Hiragino Kaku Gothic ProN", "Noto Sans JP", sans-serif; font-size: 11px;
  font-weight: 500; letter-spacing: .18em; text-decoration: none;
}
.hb-contact-btn .hb-arrow { font-family: "Zen Kaku Gothic New", "Hiragino Kaku Gothic ProN", "Noto Sans JP", sans-serif; }

/* Mobile burger */
.hb-mb-burger {
  display: none; background: none;
  border: 1px solid var(--hb-border);
  width: 42px; height: 42px; place-items: center;
  cursor: pointer; padding: 0;
}

/* ====== Hero ====== */
.hb-hero {
  position: relative; padding: 72px 32px 64px;
  overflow: hidden; background: #FFFFFF;
}
.hb-hero .hb-chars .hb-c,
.hb-hero .hb-up { opacity:1 !important; transform:none !important; transition:none !important; }

.hb-hero-svg { position: absolute; inset: 0; width: 100%; height: 100%; pointer-events: none; }

.hb-hero-display {
  font-family: "Zen Kaku Gothic New", "Noto Sans JP", sans-serif;
  font-weight: 900; letter-spacing:.04em; line-height: 1.18;
  font-size: 72px; color: #0A2846; margin: 0;
}
.hb-hero-display em {
  font-family: "Zen Kaku Gothic New", "Hiragino Kaku Gothic ProN", "Noto Sans JP", sans-serif;
  font-weight: 300; font-size: .7em;
  letter-spacing: .005em; color: #1F61AB; line-height: 1.1;
}
.hb-hero-display .hb-accent { border-bottom: 3px solid #1F61AB; padding-bottom: .05em; }

.hb-hero-badge {
  font-family: "Zen Kaku Gothic New", "Hiragino Kaku Gothic ProN", "Noto Sans JP", sans-serif; font-size: 11px;
  letter-spacing: .36em; color: var(--hb-blue);
  margin-bottom: 28px; display: flex; align-items: center; gap: 14px;
}
.hb-hero-badge::before {
  content: ''; display: inline-block; width: 8px; height: 8px;
  border-radius: 50%; background: var(--hb-blue);
}

.hb-hero-body {
  margin-top: 32px; max-width: 640px;
}
.hb-hero-body p {
  font-size: 16px; line-height: 1.9; color: var(--hb-sub); margin: 0;
}

.hb-hero-actions {
  margin-top: 36px; display: flex; flex-wrap: wrap; gap: 14px;
}

.hb-btn-primary {
  display: inline-flex; align-items: center; gap: 10px;
  padding: 14px 26px; background: #1F61AB; color: #fff;
  font-family: "Zen Kaku Gothic New", "Noto Sans JP", sans-serif;
  font-size: 14px; font-weight: 700; letter-spacing: .02em;
  text-decoration: none; border-radius: 0;
}
.hb-btn-outline {
  display: inline-flex; align-items: center; gap: 10px;
  padding: 14px 26px; background: transparent; color: #0A2846;
  border: 1px solid #0A2846;
  font-family: "Zen Kaku Gothic New", "Noto Sans JP", sans-serif;
  font-size: 14px; font-weight: 600; letter-spacing: .02em;
  text-decoration: none;
}
.hb-arrow { font-family: "Zen Kaku Gothic New", "Hiragino Kaku Gothic ProN", "Noto Sans JP", sans-serif; }

.hb-scroll-indicator {
  position: absolute; left: 32px; bottom: 48px;
  font-family: "Zen Kaku Gothic New", "Hiragino Kaku Gothic ProN", "Noto Sans JP", sans-serif; font-size: 10px;
  letter-spacing: .32em; color: #0A2846;
  display: flex; flex-direction: column; align-items: flex-start; gap: 14px;
}
.hb-scroll-indicator::before {
  content: ''; display: inline-block; width: 1px; height: 60px;
  background: #0A2846; opacity: .35;
}

/* ====== Section Common ====== */
.hb-section { padding: 104px 32px; }
.hb-section-alt { background: var(--hb-paper); }
.hb-section-inner { max-width: 1280px; margin: 0 auto; }
.hb-section-narrow { max-width: 1080px; margin: 0 auto; }

.hb-section-head {
  display: flex; align-items: baseline; gap: 18px;
  padding-bottom: 18px; border-bottom: 1px solid var(--hb-border);
  margin-bottom: 40px;
}
.hb-section-head-en {
  font-family: "Zen Kaku Gothic New", "Hiragino Kaku Gothic ProN", "Noto Sans JP", sans-serif; font-size: 11px;
  font-weight: 500; letter-spacing: .3em; color: var(--hb-blue);
  display: flex; align-items: center; gap: 10px;
}
.hb-section-head-en::before {
  content: ''; display: inline-block; width: 8px; height: 8px;
  border-radius: 50%; background: var(--hb-blue);
}
.hb-section-head-jp {
  font-family: "Zen Kaku Gothic New", "Noto Sans JP", sans-serif;
  font-weight: 500; font-size: 32px; letter-spacing:.04em; color: #0A2846;
}
.hb-section-head-count {
  margin-left: auto;
  font-family: "Zen Kaku Gothic New", "Hiragino Kaku Gothic ProN", "Noto Sans JP", sans-serif; font-size: 11px;
  letter-spacing: .18em; color: var(--hb-muted);
}

/* ====== Structure / Divisions ====== */
.hb-divisions-grid {
  display: grid; grid-template-columns: repeat(3, 1fr);
  gap: 0; border: 1px solid var(--hb-border);
}
.hb-division-card {
  padding: 48px 36px; position: relative; overflow: hidden;
  display: flex; flex-direction: column;
  border-right: 1px solid var(--hb-border);
}
.hb-division-card:last-child { border-right: none; }
.hb-division-card.bg-ghost { background: var(--hb-blue-ghost); }

.hb-division-num {
  font-family: "Zen Kaku Gothic New", "Hiragino Kaku Gothic ProN", "Noto Sans JP", sans-serif;
  font-weight: 300; font-size: 42px;
  line-height: 1; color: var(--hb-blue);
}
.hb-division-label {
  font-family: "Zen Kaku Gothic New", "Hiragino Kaku Gothic ProN", "Noto Sans JP", sans-serif; font-size: 10px;
  letter-spacing: .28em; color: var(--hb-muted);
}
.hb-division-title {
  font-family: "Zen Kaku Gothic New", "Noto Sans JP", sans-serif;
  font-weight: 800; font-size: 30px; line-height: 1.3;
  letter-spacing:.04em; margin: 0 0 22px;
}
.hb-division-desc {
  font-size: 13.5px; line-height: 2; color: var(--hb-sub); margin: 0 0 28px;
}
.hb-division-features { display: grid; gap: 8px; margin-bottom: 28px; }
.hb-division-feature {
  display: flex; align-items: center; gap: 10px;
  font-size: 12.5px; color: #0A2846; font-weight: 500;
}
.hb-division-feature::before {
  content: ''; display: inline-block; width: 5px; height: 5px;
  background: var(--hb-blue);
}
.hb-division-link {
  margin-top: auto;
  display: inline-flex; align-items: center; gap: 10px;
  font-family: "Zen Kaku Gothic New", "Hiragino Kaku Gothic ProN", "Noto Sans JP", sans-serif; font-size: 11px;
  font-weight: 600; letter-spacing: .22em; color: var(--hb-blue);
  text-decoration: none; border-bottom: 1px solid var(--hb-blue);
  padding-bottom: 6px; align-self: flex-start;
}

.hb-difference-bar {
  margin: -1px auto 0; padding: 36px 48px;
  background: #0A2846; color: #fff;
  max-width: 840px; display: grid;
  grid-template-columns: 1fr auto; gap: 32px;
  align-items: center;
}

/* ====== News Ticker / Marquee ====== */
@keyframes hb-marquee { from {transform:translateX(0);} to {transform:translateX(-50%);} }
.hb-marquee-section {
  padding: 18px 0; border-top: 1px solid var(--hb-border);
  border-bottom: 1px solid var(--hb-border); overflow: hidden;
  background: #fff;
}
.hb-marquee { display: flex; gap: 64px; animation: hb-marquee 38s linear infinite; }
.hb-marquee-item {
  display: flex; align-items: center; gap: 20px;
  white-space: nowrap; flex-shrink: 0;
  font-size: 13px; color: #0A2846;
}

/* ====== Labels ====== */
.hb-label {
  display: inline-flex; align-items: center; height: 22px; padding: 0 10px;
  font-family: "Zen Kaku Gothic New", "Hiragino Kaku Gothic ProN", "Noto Sans JP", sans-serif; font-size: 10px;
  font-weight: 500; letter-spacing: .18em;
  border: 1px solid #0A2846; color: #0A2846; line-height: 1;
}
.hb-label-blue { background: #1F61AB; color: #fff; border-color: #1F61AB; }
.hb-label-fill { background: #0A2846; color: #fff; border-color: #0A2846; }
.hb-label-ghost { background: transparent; color: #0A2846; }
.hb-label-warm { background: #F5F4F0; color: #0A2846; border-color: var(--hb-border); }

/* ====== News List ====== */
.hb-news-row {
  display: grid; grid-template-columns: 110px 110px 1fr 100px 24px;
  gap: 24px; padding: 16px 0; border-bottom: 1px solid var(--hb-border);
  align-items: center; text-decoration: none; color: #0A2846;
  transition: padding-left .35s cubic-bezier(.16,.88,.2,1), background .35s cubic-bezier(.16,.88,.2,1);
}
.hb-news-row:hover { padding-left: 14px; background: var(--hb-blue-ghost); }
.hb-news-date { font-family: "Zen Kaku Gothic New", "Hiragino Kaku Gothic ProN", "Noto Sans JP", sans-serif; font-size: 12px; color: var(--hb-muted); }
.hb-news-title { font-size: 14px; font-weight: 500; }
.hb-news-more { font-family: "Zen Kaku Gothic New", "Hiragino Kaku Gothic ProN", "Noto Sans JP", sans-serif; font-size: 11px; letter-spacing: .14em; color: var(--hb-muted); }

/* ====== Vision ====== */
.hb-vision {
  padding: 112px 32px; background: var(--hb-blue); color: #fff;
  position: relative; overflow: hidden;
}
.hb-vision-inner {
  max-width: 1280px; margin: 0 auto; position: relative;
  display: grid; grid-template-columns: 1fr 1fr; gap: 64px;
  align-items: center;
}
.hb-vision-display {
  font-family: "Zen Kaku Gothic New", "Hiragino Kaku Gothic ProN", "Noto Sans JP", sans-serif; font-weight: 300;
  font-size: clamp(96px, 11vw, 180px); line-height: .92;
  letter-spacing:.04em; margin: 0;
}

/* ====== Service Block ====== */
.hb-svc-block {
  display: grid; grid-template-columns: 100px 1fr auto;
  gap: 48px; padding: 32px 0; border-bottom: 1px solid #0A2846;
  align-items: flex-start; cursor: pointer; text-decoration: none;
  color: inherit;
  transition: padding-left .4s cubic-bezier(.16,.88,.2,1);
}
.hb-svc-block:hover { padding-left: 18px; }
.hb-svc-num {
  font-family: "Zen Kaku Gothic New", "Hiragino Kaku Gothic ProN", "Noto Sans JP", sans-serif;
  font-weight: 300; font-size: 56px;
  color: var(--hb-blue); line-height: .9;
}

/* ====== Works / Cases ====== */
.hb-works-grid {
  display: grid; grid-template-columns: repeat(3, 1fr); gap: 0;
}
.hb-work-card {
  position: relative; display: block; text-decoration: none; color: #0A2846;
  background: #fff; border: 1px solid var(--hb-border); padding: 32px;
  overflow: hidden;
  transition: transform .45s cubic-bezier(.16,.88,.2,1), border-color .35s;
}
.hb-work-card:hover { transform: translateY(-4px); border-color: #0A2846; }
.hb-work-card.fill { background: var(--hb-blue); color: #fff; border-color: var(--hb-blue); }
.hb-work-card.fill:hover { background: #0A2846; border-color: #0A2846; }
.hb-work-card.dark { background: #0A2846; color: #fff; border-color: #0A2846; }

/* ====== Issues ====== */
.hb-issues-section {
  padding: 112px 32px; background: #0A2846; color: #fff;
  position: relative; overflow: hidden;
}
.hb-issue-grid {
  display: grid; grid-template-columns: repeat(4, 1fr); gap: 0;
}
.hb-issue-card {
  padding: 28px 22px; border: 1px solid rgba(255,255,255,.12);
  margin: -1px 0 0 -1px;
  transition: background .35s, border-color .35s;
}
.hb-issue-card:hover { background: rgba(31,97,171,.18); border-color: rgba(255,255,255,.25); }
.hb-issue-num {
  font-family: "Zen Kaku Gothic New", "Hiragino Kaku Gothic ProN", "Noto Sans JP", sans-serif; font-weight: 300; font-size: 36px; color: var(--hb-blue-light);
  line-height: 1; margin-bottom: 18px;
}
.hb-issue-category {
  font-family: "Zen Kaku Gothic New", "Hiragino Kaku Gothic ProN", "Noto Sans JP", sans-serif; font-size: 9px;
  letter-spacing: .22em; color: var(--hb-blue-light);
  margin-bottom: 14px;
}

/* ====== Approach ====== */
.hb-approach-grid {
  display: grid; grid-template-columns: repeat(4, 1fr); gap: 32px;
}
.hb-approach-card { padding: 32px 0; border-top: 2px solid #0A2846; }
.hb-approach-num {
  font-family: "Zen Kaku Gothic New", "Hiragino Kaku Gothic ProN", "Noto Sans JP", sans-serif; font-weight: 300; font-size: 48px; color: var(--hb-blue); line-height: 1;
  margin-bottom: 16px;
}
.hb-approach-en {
  font-family: "Zen Kaku Gothic New", "Hiragino Kaku Gothic ProN", "Noto Sans JP", sans-serif; font-size: 10px;
  letter-spacing: .28em; color: var(--hb-muted); margin-bottom: 6px;
}

/* ====== Blog / Insights ====== */
.hb-blog-grid {
  display: grid; grid-template-columns: repeat(3, 1fr); gap: 0;
}
.hb-blog-card {
  padding: 32px; border: 1px solid var(--hb-border);
  margin: -1px 0 0 -1px; text-decoration: none; color: inherit;
  display: flex; flex-direction: column;
  transition: background .35s;
}
.hb-blog-card:hover { background: var(--hb-blue-ghost); }

/* ====== Recruit ====== */
.hb-recruit {
  padding: 104px 32px; background: #fff;
  position: relative; overflow: hidden;
}
.hb-recruit-inner {
  max-width: 1280px; margin: 0 auto; position: relative;
  display: grid; grid-template-columns: 1fr 1fr; gap: 64px;
}
.hb-job-row {
  display: grid; grid-template-columns: 64px 1fr auto; gap: 18px;
  padding: 18px 0; border-bottom: 1px solid var(--hb-border);
  align-items: center; text-decoration: none; color: inherit;
  transition: padding-left .35s;
}
.hb-job-row:hover { padding-left: 12px; }

/* ====== Voices ====== */
.hb-voices-grid {
  display: grid; grid-template-columns: repeat(3, 1fr); gap: 32px;
}
.hb-voice-card {
  padding: 36px 28px; border: 1px solid var(--hb-border);
  position: relative;
}
.hb-voice-quote {
  font-family: "Zen Kaku Gothic New", "Hiragino Kaku Gothic ProN", "Noto Sans JP", sans-serif; font-size: 64px; color: var(--hb-blue); line-height: 1;
  position: absolute; top: 16px; left: 24px; opacity: .3;
}

/* ====== Pickup ====== */
.hb-pickup-card {
  position: relative; display: block; text-decoration: none; color: #0A2846;
  background: #fff; border: 1px solid var(--hb-border); padding: 32px;
  aspect-ratio: 4/3.4; overflow: hidden;
  transition: transform .45s cubic-bezier(.16,.88,.2,1), border-color .35s, background .35s;
}
.hb-pickup-card:hover { transform: translateY(-4px); border-color: #0A2846; }
.hb-pickup-card.fill { background: #1F61AB; color: #fff; border-color: #1F61AB; }
.hb-pickup-card.fill:hover { background: #0A2846; border-color: #0A2846; }
.hb-pickup-card.dark { background: #0A2846; color: #fff; border-color: #0A2846; }

/* ====== Partners ====== */
.hb-partners-grid {
  display: flex; flex-wrap: wrap; gap: 24px;
  justify-content: center; align-items: center;
}
.hb-partner-logo { height: 36px; opacity: .55; filter: grayscale(1); transition: opacity .3s; }
.hb-partner-logo:hover { opacity: 1; filter: none; }

/* ====== CTA ====== */
.hb-cta-section {
  padding: 120px 32px 132px; background: #1F61AB; color: #fff;
  position: relative; overflow: hidden;
}
.hb-cta {
  position: relative; display: inline-flex; align-items: center; gap: 14px;
  padding: 18px 32px; background: #0A2846; color: #fff;
  text-decoration: none; border-radius: 999px; overflow: hidden;
  font-family: "Zen Kaku Gothic New", "Hiragino Kaku Gothic ProN", "Noto Sans JP", sans-serif; font-size: 13px;
  font-weight: 500; letter-spacing: .04em;
}
.hb-cta::before {
  content: ''; position: absolute; inset: 0;
  background: #1F61AB; transform: translateY(101%);
  transition: transform .5s cubic-bezier(.16,.88,.2,1); border-radius: 999px;
}
.hb-cta:hover::before { transform: translateY(0); }
.hb-cta > * { position: relative; z-index: 1; }
.hb-cta-outline {
  background: transparent; color: #0A2846;
  border: 1px solid #0A2846;
}
.hb-cta-outline::before { background: #0A2846; }
.hb-cta-outline:hover { color: #fff; }

.hb-cta-white { background: #fff; color: #0A2846; }
.hb-cta-white::before { background: #0A2846; }
.hb-cta-white:hover { color: #fff; }

/* ====== Footer ====== */
.hb-footer {
  padding: 88px 32px 36px; background: #0A2846; color: #fff;
  position: relative; overflow: hidden;
}
.hb-footer-inner { max-width: 1280px; margin: 0 auto; position: relative; }

.hb-footer-top {
  padding: 24px 0 40px;
  border-bottom: 1px solid rgba(255,255,255,.15);
  display: flex; align-items: flex-end; justify-content: space-between;
}
.hb-footer-brand {
  font-family: "Zen Kaku Gothic New", "Hiragino Kaku Gothic ProN", "Noto Sans JP", sans-serif;
  font-size: clamp(72px, 8vw, 120px); font-weight: 200;
  letter-spacing:.04em; line-height: 1;
}
.hb-footer-brand-dot {
  color: #E8EFF8;
  font-family: "Zen Kaku Gothic New", "Hiragino Kaku Gothic ProN", "Noto Sans JP", sans-serif;
  font-weight: 300;
}
.hb-footer-tagline {
  font-family: "Zen Kaku Gothic New", "Hiragino Kaku Gothic ProN", "Noto Sans JP", sans-serif;
  font-weight: 300; font-size: 22px;
  color: #E8EFF8; margin-top: 8px; letter-spacing: .02em;
}

.hb-footer-grid {
  display: grid; grid-template-columns: 1.6fr 1fr 1fr 1fr 1fr;
  gap: 40px; padding: 56px 0;
  border-bottom: 1px solid rgba(255,255,255,.15);
}
.hb-footer-heading {
  font-family: "Zen Kaku Gothic New", "Hiragino Kaku Gothic ProN", "Noto Sans JP", sans-serif; font-size: 10px;
  font-weight: 500; letter-spacing: .32em; color: #E8EFF8;
  margin-bottom: 22px;
}
.hb-footer-link {
  display: block; color: #fff; text-decoration: none;
  font-size: 12.5px; padding: 6px 0; opacity: .85;
}
.hb-footer-link:hover { opacity: 1; }
.hb-footer-address {
  font-family: "Zen Kaku Gothic New", "Hiragino Kaku Gothic ProN", "Noto Sans JP", sans-serif; font-size: 11px;
  color: rgba(255,255,255,.55); line-height: 1.85;
}
.hb-footer-desc {
  font-size: 12.5px; line-height: 2; color: rgba(255,255,255,.7);
  margin: 18px 0 22px; max-width: 300px;
}

.hb-footer-group {
  padding: 40px 0; border-bottom: 1px solid rgba(255,255,255,.15);
}
.hb-footer-group-grid {
  display: grid; grid-template-columns: repeat(3, 1fr); gap: 24px;
}
.hb-footer-group-card {
  display: block; padding: 20px 18px;
  border: 1px solid rgba(255,255,255,.15);
  text-decoration: none; color: #fff;
}

.hb-footer-bottom {
  display: flex; flex-wrap: wrap; gap: 18px;
  justify-content: space-between; padding-top: 28px;
  font-family: "Zen Kaku Gothic New", "Hiragino Kaku Gothic ProN", "Noto Sans JP", sans-serif; font-size: 10.5px;
  color: rgba(255,255,255,.5);
}

.hb-social-links { display: flex; gap: 8px; }
.hb-social-link {
  width: 36px; height: 36px; border-radius: 50%;
  border: 1px solid rgba(255,255,255,.25);
  display: grid; place-items: center;
}
.hb-social-link img { width: 13px; height: 13px; filter: invert(1); }

/* ====== SVG Decorations ====== */
.hb-deco-svg {
  position: absolute; pointer-events: none;
}

/* ====== Responsive ====== */
@media (max-width: 880px) {
  .hb-pc-nav { display: none !important; }
  .hb-mb-burger { display: grid !important; }

  .hb-hero-display { font-size: 36px; }
  .hb-divisions-grid { grid-template-columns: 1fr; }
  .hb-division-card { border-right: none; border-bottom: 1px solid var(--hb-border); }
  .hb-division-card:last-child { border-bottom: none; }
  .hb-issue-grid { grid-template-columns: repeat(2, 1fr); }
  .hb-approach-grid { grid-template-columns: repeat(2, 1fr); }
  .hb-works-grid { grid-template-columns: 1fr; }
  .hb-blog-grid { grid-template-columns: 1fr; }
  .hb-voices-grid { grid-template-columns: 1fr; }
  .hb-vision-inner { grid-template-columns: 1fr; }
  .hb-vision-display { font-size: 64px; }
  .hb-recruit-inner { grid-template-columns: 1fr; }
  .hb-difference-bar { grid-template-columns: 1fr; text-align: center; }
  .hb-footer-grid { grid-template-columns: 1fr 1fr; }
  .hb-footer-group-grid { grid-template-columns: 1fr; }
  .hb-news-row { grid-template-columns: 80px 1fr; gap: 12px; }
  .hb-news-row .hb-label,
  .hb-news-row .hb-news-more,
  .hb-news-row .hb-arrow { display: none; }
  .hb-section { padding: 64px 20px; }
  .hb-hero { padding: 48px 20px; }
}

@media (max-width: 480px) {
  .hb-hero-display { font-size: 28px; }
  .hb-section-head-jp { font-size: 22px; }
  .hb-issue-grid { grid-template-columns: 1fr; }
  .hb-approach-grid { grid-template-columns: 1fr; }
  .hb-footer-grid { grid-template-columns: 1fr; }
}


/* ===== training page specific ===== */

/* Training page specific */
.hb-training-grid { display:grid; grid-template-columns:repeat(auto-fill,minmax(320px,1fr)); gap:0; }
.hb-training-card {
  padding:32px 28px; border:1px solid var(--hb-border); margin:-1px 0 0 -1px;
  display:flex; flex-direction:column; text-decoration:none; color:inherit;
  transition: background .35s cubic-bezier(.16,.88,.2,1), border-color .35s;
}
.hb-training-card:hover { background:var(--hb-blue-ghost); border-color:var(--hb-blue); }
.hb-training-tag {
  font-family: "Zen Kaku Gothic New", "Hiragino Kaku Gothic ProN", "Noto Sans JP", sans-serif; font-size:10px; font-weight:500;
  letter-spacing:.18em; display:inline-flex; align-items:center;
  height:22px; padding:0 10px; margin-bottom:16px; line-height:1;
}
.hb-training-tag.individual { background:#E8F5E9; color:#2E7D32; border:1px solid #C8E6C9; }
.hb-training-tag.corporate  { background:#E3F2FD; color:#1565C0; border:1px solid #BBDEFB; }
.hb-training-tag.dispatch   { background:#FFF3E0; color:#E65100; border:1px solid #FFE0B2; }
.hb-training-tag.coming     { background:#F5F5F5; color:#757575; border:1px solid #E0E0E0; }
.hb-training-title {
  font-family:"Zen Kaku Gothic New","Noto Sans JP",sans-serif;
  font-weight:700; font-size:17px; color:#0A2846; margin-bottom:10px; line-height:1.5;
}
.hb-training-desc { font-size:13px; line-height:1.9; color:var(--hb-sub); margin-bottom:16px; flex:1; }
.hb-training-price {
  font-family:"Zen Kaku Gothic New", "Hiragino Kaku Gothic ProN", "Noto Sans JP", sans-serif; font-size:12px; font-weight:600;
  color:var(--hb-blue); letter-spacing:.02em;
}
.hb-training-arrow { margin-top:14px; font-family: "Zen Kaku Gothic New", "Hiragino Kaku Gothic ProN", "Noto Sans JP", sans-serif; font-size:10px; letter-spacing:.18em; color:var(--hb-blue); font-weight:600; }

.hb-tier-header {
  display:flex; align-items:baseline; gap:14px;
  padding-bottom:16px; border-bottom:1px solid var(--hb-border); margin-bottom:28px;
}
.hb-tier-num {
  font-family:"Zen Kaku Gothic New", "Hiragino Kaku Gothic ProN", "Noto Sans JP", sans-serif; font-weight:300;
  font-size:36px; color:var(--hb-blue); line-height:1;
}
.hb-tier-label {
  font-family:"Zen Kaku Gothic New","Noto Sans JP",sans-serif;
  font-weight:700; font-size:22px; letter-spacing:.04em;
}
.hb-tier-en {
  font-family: "Zen Kaku Gothic New", "Hiragino Kaku Gothic ProN", "Noto Sans JP", sans-serif; font-size:10px; letter-spacing:.28em;
  color:var(--hb-muted); margin-left:auto;
}
.hb-tier-section { margin-bottom:64px; }

.hb-metrics {
  display:grid; grid-template-columns:repeat(4,1fr); gap:32px;
  margin-top:48px; padding-top:32px; border-top:1px solid rgba(255,255,255,.25);
}
.hb-metric-val {
  font-family:"Zen Kaku Gothic New", "Hiragino Kaku Gothic ProN", "Noto Sans JP", sans-serif; font-weight:300;
  font-size:48px; color:#fff; line-height:1; margin-bottom:8px;
}
.hb-metric-val small { font-size:.45em; font-style:normal; opacity:.7; }
.hb-metric-label { font-size:12px; color:rgba(255,255,255,.7); letter-spacing:.04em; }

.hb-partner-row {
  display:flex; flex-wrap:wrap; gap:40px; align-items:center;
  justify-content:center; padding:32px 0;
}

.hb-pain-grid {
  display:grid; grid-template-columns:repeat(3,1fr); gap:0;
  border:1px solid var(--hb-border);
}
.hb-pain-card {
  padding:32px 28px; border-right:1px solid var(--hb-border); border-bottom:1px solid var(--hb-border);
  transition: background .35s;
}
.hb-pain-card:nth-child(3n) { border-right:none; }
.hb-pain-card:nth-child(n+4) { border-bottom:none; }
.hb-pain-card:hover { background:var(--hb-blue-ghost); }

.hb-step-grid {
  display:grid; grid-template-columns:repeat(5,1fr); gap:0;
  border:1px solid var(--hb-border);
}
.hb-step-card {
  padding:36px 24px; border-right:1px solid var(--hb-border);
  position:relative;
}
.hb-step-card:last-child { border-right:none; }

.hb-career-grid {
  display:grid; grid-template-columns:repeat(4,1fr); gap:0;
  border:1px solid var(--hb-border);
}
.hb-career-card {
  padding:32px 24px; border-right:1px solid var(--hb-border);
  transition: background .35s;
}
.hb-career-card:last-child { border-right:none; }
.hb-career-card:hover { background:rgba(255,255,255,.08); }

.hb-case-grid {
  display:grid; grid-template-columns:repeat(3,1fr); gap:0;
  border:1px solid var(--hb-border);
}
.hb-case-card {
  padding:36px 28px; border-right:1px solid var(--hb-border);
}
.hb-case-card:last-child { border-right:none; }

.hb-faq-item {
  padding:24px 0; border-bottom:1px solid var(--hb-border);
}
.hb-faq-q {
  font-weight:700; font-size:15px; margin-bottom:12px;
  display:flex; align-items:baseline; gap:14px;
}
.hb-faq-a {
  font-size:13.5px; line-height:2; color:var(--hb-sub);
  padding-left:38px;
}
.hb-faq-badge {
  font-family:"Zen Kaku Gothic New", "Hiragino Kaku Gothic ProN", "Noto Sans JP", sans-serif; font-weight:300;
  font-size:24px; color:var(--hb-blue); line-height:1; flex-shrink:0;
}

.hb-price-table {
  width:100%; border-collapse:collapse; font-size:14px;
}
.hb-price-table th {
  background:var(--hb-blue); color:#fff; padding:14px 20px;
  font-family: "Zen Kaku Gothic New", "Hiragino Kaku Gothic ProN", "Noto Sans JP", sans-serif; font-size:11px; font-weight:600;
  letter-spacing:.12em; text-align:left;
}
.hb-price-table td {
  padding:16px 20px; border-bottom:1px solid var(--hb-border);
}
.hb-price-table tr:nth-child(even) td { background:var(--hb-blue-ghost); }

.hb-line-btn {
  display:inline-flex; align-items:center; gap:10px;
  padding:14px 28px; background:#06C755; color:#fff;
  font-family:"Zen Kaku Gothic New","Noto Sans JP",sans-serif;
  font-size:14px; font-weight:700; letter-spacing:.02em;
  text-decoration:none; border-radius:0;
}

@media (max-width:880px) {
  .hb-training-grid { grid-template-columns:1fr; }
  .hb-metrics { grid-template-columns:repeat(2,1fr); gap:24px; }
  .hb-pain-grid { grid-template-columns:1fr; }
  .hb-pain-card { border-right:none !important; border-bottom:1px solid var(--hb-border) !important; }
  .hb-pain-card:last-child { border-bottom:none !important; }
  .hb-step-grid { grid-template-columns:1fr; }
  .hb-step-card { border-right:none; border-bottom:1px solid var(--hb-border); }
  .hb-step-card:last-child { border-bottom:none; }
  .hb-career-grid { grid-template-columns:repeat(2,1fr); }
  .hb-career-card:nth-child(2n) { border-right:none; }
  .hb-career-card { border-bottom:1px solid var(--hb-border); }
  .hb-case-grid { grid-template-columns:1fr; }
  .hb-case-card { border-right:none; border-bottom:1px solid var(--hb-border); }
  .hb-case-card:last-child { border-bottom:none; }
}
@media (max-width:480px) {
  .hb-metrics { grid-template-columns:1fr; text-align:center; }
  .hb-career-grid { grid-template-columns:1fr; }
  .hb-career-card { border-right:none; }
}


/* ===== variant-d ローダー干渉のリセット + モバイルメニュー (issue #24) ===== */
#hb-front-root { max-width:none !important; padding:0 !important; margin:0 !important; }
.hb-academy-lp { width:100%; }
.hb-academy-mbmenu { display:none; position:absolute; top:100%; left:0; right:0; background:#fff; border-top:1px solid var(--hb-border); box-shadow:0 12px 24px rgba(0,0,0,.08); flex-direction:column; padding:8px 0; z-index:50; }
.hb-academy-mbmenu.is-open { display:flex; }
.hb-academy-mbmenu a { padding:14px 24px; font-family:"Zen Kaku Gothic New","Noto Sans JP",sans-serif; font-size:15px; font-weight:700; color:#0A2846; text-decoration:none; border-bottom:1px solid var(--hb-border); }
.hb-academy-mbline { background:#06C755; color:#fff !important; border-bottom:none !important; margin:8px 16px 4px; text-align:center; border-radius:2px; }
@media (min-width:881px){ .hb-academy-mbmenu { display:none !important; } }


/* ===== issue#24 14項目改修 追加CSS ===== */
/* CTA DUO */
.hb-cta-duo { padding:36px 32px; border-bottom:1px solid var(--hb-border); }
.hb-cta-duo-inner { max-width:1080px; margin:0 auto; display:grid; grid-template-columns:1fr 1fr; gap:28px; }
.hb-cta-duo-col { display:flex; flex-direction:column; gap:10px; }
.hb-cta-duo-note { font-size:11.5px; line-height:1.7; color:var(--hb-muted); text-align:center; }
.hb-apply-btn { display:inline-flex; align-items:center; gap:10px; padding:14px 28px; background:var(--hb-blue); color:#fff; font-family:"Zen Kaku Gothic New","Noto Sans JP",sans-serif; font-size:14px; font-weight:700; letter-spacing:.02em; text-decoration:none; border-radius:0; }
.hb-apply-btn-inverse { background:#fff; color:var(--hb-blue); }
/* HERO infobar */
.hb-hero-infobar { margin-top:26px; display:inline-flex; align-items:center; gap:14px; padding:12px 22px; border:1px solid rgba(255,255,255,.3); font-family:"Zen Kaku Gothic New", "Hiragino Kaku Gothic ProN", "Noto Sans JP", sans-serif; font-size:13px; color:rgba(255,255,255,.85); }
.hb-hero-infobar b { font-size:17px; color:#fff; font-weight:600; margin-right:4px; }
.hb-infobar-sep { color:rgba(255,255,255,.35); }
/* BA table */
.hb-ba-table { width:100%; border-collapse:collapse; font-size:14px; max-width:760px; }
.hb-ba-table th { background:var(--hb-blue); color:#fff; padding:12px 18px; font-family: "Zen Kaku Gothic New", "Hiragino Kaku Gothic ProN", "Noto Sans JP", sans-serif; font-size:11px; font-weight:600; letter-spacing:.12em; text-align:left; }
.hb-ba-table th:nth-child(2), .hb-ba-table th:nth-child(3) { text-align:center; width:90px; }
.hb-ba-table td { padding:13px 18px; border-bottom:1px solid var(--hb-border); }
.hb-ba-table td.hb-ba-x { text-align:center; color:var(--hb-muted); font-weight:700; }
.hb-ba-table td.hb-ba-o { text-align:center; color:var(--hb-blue); font-weight:700; font-size:16px; }
.hb-ba-table tr:nth-child(even) td { background:var(--hb-blue-ghost); }
/* Market Value */
.hb-income-grid { display:grid; grid-template-columns:1fr auto 1fr; gap:24px; align-items:stretch; max-width:880px; }
.hb-income-card { border:1px solid var(--hb-border); padding:28px; background:#fff; }
.hb-income-card.hb-income-after { border-color:var(--hb-blue); background:var(--hb-blue-ghost); }
.hb-income-tag { font-family: "Zen Kaku Gothic New", "Hiragino Kaku Gothic ProN", "Noto Sans JP", sans-serif; font-size:10.5px; letter-spacing:.18em; font-weight:600; color:var(--hb-muted); margin-bottom:10px; }
.hb-income-sub { font-size:12.5px; color:var(--hb-sub); margin-bottom:14px; }
.hb-income-val { font-family:"Zen Kaku Gothic New", "Hiragino Kaku Gothic ProN", "Noto Sans JP", sans-serif; font-weight:400; font-size:40px; line-height:1; color:#0A2846; }
.hb-income-val small { font-size:.4em; font-style:normal; color:var(--hb-muted); margin-left:4px; }
.hb-income-note { margin-top:14px; font-size:12px; color:var(--hb-sub); }
.hb-income-arrow { display:flex; flex-direction:column; align-items:center; justify-content:center; gap:6px; font-size:26px; color:var(--hb-blue); font-weight:700; }
.hb-income-arrow span { font-family:"Zen Kaku Gothic New", "Hiragino Kaku Gothic ProN", "Noto Sans JP", sans-serif; font-size:11px; color:var(--hb-blue); white-space:nowrap; }
.hb-remote-strip { margin-top:28px; padding:16px 22px; border:1px solid var(--hb-border); background:#fff; font-size:13.5px; color:var(--hb-sub); max-width:880px; }
.hb-remote-strip b { font-family:"Zen Kaku Gothic New", "Hiragino Kaku Gothic ProN", "Noto Sans JP", sans-serif; font-size:26px; color:var(--hb-blue); margin:0 4px; }
/* Curriculum */
.hb-lesson-list { display:grid; grid-template-columns:1fr 1fr; gap:0 32px; border-top:1px solid var(--hb-border); max-width:1000px; }
.hb-lesson-row { display:flex; align-items:baseline; gap:14px; padding:13px 4px; border-bottom:1px solid var(--hb-border); }
.hb-lesson-no { font-family:"Zen Kaku Gothic New", "Hiragino Kaku Gothic ProN", "Noto Sans JP", sans-serif; font-size:10.5px; color:var(--hb-blue); font-weight:600; white-space:nowrap; }
.hb-lesson-t { font-size:13px; color:#0A2846; flex:1; line-height:1.6; }
.hb-lesson-tag { font-family: "Zen Kaku Gothic New", "Hiragino Kaku Gothic ProN", "Noto Sans JP", sans-serif; font-size:9.5px; letter-spacing:.12em; color:var(--hb-muted); border:1px solid var(--hb-border); padding:2px 8px; white-space:nowrap; }
/* Video */
.hb-video-fig { margin:40px 0 0; max-width:840px; border:1px solid var(--hb-border); }
.hb-video-cap-head { font-family: "Zen Kaku Gothic New", "Hiragino Kaku Gothic ProN", "Noto Sans JP", sans-serif; font-size:10px; letter-spacing:.28em; color:var(--hb-blue); font-weight:700; padding:14px 20px; border-bottom:1px solid var(--hb-border); background:var(--hb-blue-ghost); }
.hb-video-fig figcaption { padding:16px 20px; font-size:13px; line-height:1.9; color:var(--hb-sub); background:#fff; }
.hb-video-fig figcaption b { color:#0A2846; }
/* Timetable */
.hb-tt-block { margin-bottom:40px; max-width:920px; }
.hb-tt-day { font-family:"Zen Kaku Gothic New","Noto Sans JP",sans-serif; font-weight:700; font-size:17px; margin-bottom:14px; padding-left:12px; border-left:3px solid var(--hb-blue); }
.hb-tt-table { width:100%; border-collapse:collapse; font-size:13px; background:#fff; }
.hb-tt-table th { background:#0A2846; color:#fff; padding:10px 16px; font-family: "Zen Kaku Gothic New", "Hiragino Kaku Gothic ProN", "Noto Sans JP", sans-serif; font-size:10px; letter-spacing:.18em; text-align:left; }
.hb-tt-table td { padding:12px 16px; border-bottom:1px solid var(--hb-border); vertical-align:top; }
.hb-tt-time { font-family:"Zen Kaku Gothic New", "Hiragino Kaku Gothic ProN", "Noto Sans JP", sans-serif; font-size:12px; color:var(--hb-blue); white-space:nowrap; width:120px; }
.hb-tt-topic { font-weight:700; color:#0A2846; width:220px; }
.hb-tt-detail { color:var(--hb-sub); line-height:1.8; }
/* Instructors */
.hb-ins-grid { display:grid; grid-template-columns:1fr 1fr; gap:32px; }
.hb-ins-card { border:1px solid var(--hb-border); background:#fff; display:flex; flex-direction:column; }
.hb-ins-photo { aspect-ratio:5/4; overflow:hidden; background:var(--hb-blue-ghost); }
.hb-ins-photo img { width:100%; height:100%; object-fit:cover; object-position:top; display:block; }
.hb-ins-body { padding:26px 28px; }
.hb-ins-name { font-family:"Zen Kaku Gothic New","Noto Sans JP",sans-serif; font-weight:700; font-size:20px; }
.hb-ins-name span { font-size:11px; color:var(--hb-muted); font-weight:500; margin-left:8px; }
.hb-ins-title { font-size:12px; color:var(--hb-blue); font-weight:700; margin:6px 0 14px; }
.hb-ins-body p { font-size:13px; line-height:2; color:var(--hb-sub); margin:0 0 16px; }
.hb-ins-badges { display:flex; flex-wrap:wrap; gap:8px; }
.hb-ins-badges span { font-size:11px; color:var(--hb-blue); border:1px solid var(--hb-blue); padding:4px 10px; }
/* Case thumbs */
.hb-case-thumb-grid { display:grid; grid-template-columns:repeat(2,1fr); gap:24px; max-width:1000px; }
.hb-case-thumb-card { border:1px solid var(--hb-border); background:#fff; text-decoration:none; color:inherit; display:flex; flex-direction:column; transition:border-color .3s; }
.hb-case-thumb-card:hover { border-color:var(--hb-blue); }
.hb-case-thumb { aspect-ratio:16/9; overflow:hidden; background:var(--hb-blue-ghost); display:flex; align-items:center; justify-content:center; }
.hb-case-thumb img { width:100%; height:100%; object-fit:contain; display:block; padding:8px; box-sizing:border-box; }
.hb-case-thumb-body { padding:18px 20px; display:flex; flex-direction:column; gap:8px; flex:1; }
.hb-case-thumb-tag { font-family: "Zen Kaku Gothic New", "Hiragino Kaku Gothic ProN", "Noto Sans JP", sans-serif; font-size:9.5px; letter-spacing:.22em; color:var(--hb-blue); font-weight:700; }
.hb-case-thumb-t { font-size:13.5px; font-weight:700; line-height:1.7; color:#0A2846; flex:1; }
.hb-case-thumb-link { font-family: "Zen Kaku Gothic New", "Hiragino Kaku Gothic ProN", "Noto Sans JP", sans-serif; font-size:11px; color:var(--hb-blue); }
/* Voices */
.hb-voice-card { border:1px solid var(--hb-border); background:#fff; padding:28px 30px; margin-bottom:24px; }
.hb-voice-head { display:flex; flex-wrap:wrap; gap:10px; align-items:baseline; justify-content:space-between; margin-bottom:12px; }
.hb-voice-case { font-family: "Zen Kaku Gothic New", "Hiragino Kaku Gothic ProN", "Noto Sans JP", sans-serif; font-size:10px; letter-spacing:.18em; color:var(--hb-blue); font-weight:700; }
.hb-voice-who { font-size:12.5px; color:var(--hb-muted); font-weight:600; }
.hb-voice-t { font-family:"Zen Kaku Gothic New","Noto Sans JP",sans-serif; font-weight:700; font-size:19px; margin-bottom:12px; }
.hb-voice-p { font-size:13.5px; line-height:2; color:var(--hb-sub); margin:0 0 20px; }
.hb-voice-by { display:block; margin-top:8px; font-size:12px; color:var(--hb-muted); }
.hb-voice-compare { display:grid; grid-template-columns:1fr auto 1fr; gap:18px; align-items:stretch; margin-bottom:18px; max-width:720px; }
.hb-voice-cb { border:1px solid var(--hb-border); padding:18px 20px; }
.hb-voice-cb-after { border-color:var(--hb-blue); background:var(--hb-blue-ghost); }
.hb-voice-cb-tag { font-family: "Zen Kaku Gothic New", "Hiragino Kaku Gothic ProN", "Noto Sans JP", sans-serif; font-size:10px; letter-spacing:.16em; color:var(--hb-muted); font-weight:600; margin-bottom:8px; }
.hb-voice-cb-val { font-family:"Zen Kaku Gothic New", "Hiragino Kaku Gothic ProN", "Noto Sans JP", sans-serif; font-size:32px; line-height:1; color:#0A2846; }
.hb-voice-cb-after .hb-voice-cb-val { color:var(--hb-blue); }
.hb-voice-cb-val small { font-size:.45em; font-style:normal; }
.hb-voice-cb-note { margin-top:8px; font-size:11.5px; color:var(--hb-sub); }
.hb-voice-cb-arrow { display:flex; flex-direction:column; align-items:center; justify-content:center; gap:4px; font-size:22px; color:var(--hb-blue); font-weight:700; }
.hb-voice-cb-arrow span { font-family:"Zen Kaku Gothic New", "Hiragino Kaku Gothic ProN", "Noto Sans JP", sans-serif; font-size:10.5px; white-space:nowrap; }
.hb-voice-detail summary { cursor:pointer; font-size:12.5px; font-weight:700; color:var(--hb-blue); padding:8px 0; }
.hb-voice-detail .hb-ba-table { margin-top:12px; font-size:13px; }
.hb-voice-skills th { padding:9px 14px; }
.hb-voice-skills td { padding:9px 14px; }
/* Cashback */
.hb-cashback { margin-top:48px; border:1px solid var(--hb-blue); background:var(--hb-blue-ghost); padding:30px 32px; }
.hb-cashback-head { font-size:16px; margin-bottom:12px; color:#0A2846; }
.hb-cashback-head b { color:var(--hb-blue); }
.hb-cashback-steps { display:grid; grid-template-columns:1fr auto 1fr auto 1fr auto 1fr; gap:10px; align-items:stretch; }
.hb-cb-step { background:#fff; border:1px solid var(--hb-border); padding:16px 14px; text-align:center; }
.hb-cb-step.hb-cb-result { border-color:var(--hb-blue); background:var(--hb-blue); color:#fff; }
.hb-cb-no { font-family: "Zen Kaku Gothic New", "Hiragino Kaku Gothic ProN", "Noto Sans JP", sans-serif; font-size:9.5px; letter-spacing:.2em; font-weight:700; color:var(--hb-blue); margin-bottom:6px; }
.hb-cb-result .hb-cb-no { color:rgba(255,255,255,.8); }
.hb-cb-t { font-weight:700; font-size:13.5px; margin-bottom:4px; }
.hb-cb-d { font-size:11px; color:var(--hb-sub); line-height:1.6; }
.hb-cb-result .hb-cb-d { color:rgba(255,255,255,.85); }
.hb-cb-arr { display:flex; align-items:center; font-size:20px; color:var(--hb-blue); font-weight:700; }
.hb-cashback-note { margin-top:16px; font-size:13px; font-weight:700; color:#0A2846; }
.hb-cashback-note span { font-weight:400; font-size:11px; color:var(--hb-muted); }
.hb-guarantee { margin-top:20px; background:#fff; border:1px solid var(--hb-border); padding:20px 24px; }
.hb-guarantee-t { font-weight:700; font-size:14px; margin-bottom:8px; }
.hb-guarantee p { font-size:12.5px; line-height:2; color:var(--hb-sub); margin:0; }
.hb-guarantee span { font-size:11px; color:var(--hb-muted); }
/* mobile */
@media (max-width:880px) {
  .hb-cta-duo-inner { grid-template-columns:1fr; }
  .hb-income-grid { grid-template-columns:1fr; }
  .hb-income-arrow { transform:rotate(90deg); padding:8px 0; }
  .hb-lesson-list { grid-template-columns:1fr; }
  .hb-ins-grid { grid-template-columns:1fr; }
  .hb-case-thumb-grid { grid-template-columns:1fr; }
  .hb-voice-compare { grid-template-columns:1fr; }
  .hb-voice-cb-arrow { transform:rotate(90deg); padding:6px 0; }
  .hb-cashback-steps { grid-template-columns:1fr; }
  .hb-cb-arr { transform:rotate(90deg); justify-content:center; }
  .hb-tt-topic { width:auto; }
  .hb-hero-infobar { flex-wrap:wrap; gap:8px; font-size:11.5px; }
}


/* ===== 高橋レビュー #18-29 追加CSS ===== */
.hb-skill-list { margin:0; padding:0; list-style:none; display:grid; grid-template-columns:1fr 1fr; gap:10px 32px; max-width:760px; }
.hb-skill-list li { display:flex; gap:10px; align-items:baseline; font-size:14.5px; font-weight:600; color:#0A2846; padding:10px 0; border-bottom:1px solid var(--hb-border); }
.hb-skill-list li span { color:var(--hb-blue); font-weight:700; flex:0 0 auto; }
.hb-skill-list-sm { max-width:640px; gap:4px 28px; }
.hb-skill-list-sm li { font-size:13px; padding:6px 0; }
.hb-voice-skill-block { margin-top:6px; }
.hb-voice-skill-t { font-size:12.5px; font-weight:700; color:var(--hb-blue); margin-bottom:8px; }
@media (max-width:880px) { .hb-skill-list { grid-template-columns:1fr; } }

/* group footer (issue#24-17/33) */
.hb-group-grid { display:grid; grid-template-columns:repeat(3,1fr); gap:20px; }
@media (max-width:880px) { .hb-group-grid { grid-template-columns:1fr; } }

/* program overview diagrams + bridge caption (issue#73) */
.hb-overview-fig { margin:0; max-width:960px; margin-left:auto; margin-right:auto; }
.hb-overview-fig img { width:100%; height:auto; display:block; border:1px solid var(--hb-border); border-radius:4px; }
.hb-bridge-cap { max-width:960px; margin:0 auto; padding:48px 0; text-align:center; }
.hb-bridge-lead { font-size:1.4rem; font-weight:700; line-height:1.5; color:#0A2846; margin:0 0 16px; }
.hb-bridge-body { font-size:1rem; line-height:1.8; color:var(--hb-sub); margin:0; }
@media (max-width:768px) {
  .hb-bridge-cap { padding:32px 0; }
  .hb-bridge-lead { font-size:1.2rem; }
  .hb-bridge-body { font-size:.95rem; }
}
`;
  const HTML = `

<!-- ====== HEADER ====== -->
<header class="hb-header">
  <a href="/" class="hb-header-logo"><img src="__ASSETS__hatenabase_logo.png" alt="はてなベース株式会社" style="height:32px"></a>
  <nav class="hb-pc-nav">
    <a href="#programs" class="hb-nav-item active">
      <span class="hb-nav-jp">研修ラインナップ</span>
      <span class="hb-nav-underline"></span>
    </a>
    <a href="#flow" class="hb-nav-item">
      <span class="hb-nav-jp">受講の流れ</span>
      <span class="hb-nav-underline"></span>
    </a>
    <a href="#career" class="hb-nav-item">
      <span class="hb-nav-jp">就労先</span>
      <span class="hb-nav-underline"></span>
    </a>
    <a href="#pricing" class="hb-nav-item">
      <span class="hb-nav-jp">料金</span>
      <span class="hb-nav-underline"></span>
    </a>
    <a href="#faq" class="hb-nav-item">
      <span class="hb-nav-jp">よくある質問</span>
      <span class="hb-nav-underline"></span>
    </a>
    <span class="hb-nav-divider"></span>
    <a href="https://lin.ee/QnI7WzZ" class="hb-contact-btn" style="background:#06C755">LINE登録 <span class="hb-arrow">↗</span></a>
  </nav>
  <button class="hb-mb-burger" aria-label="menu">
    <div style="position:relative;width:18px;height:12px;margin:0 auto">
      <span style="position:absolute;left:0;right:0;top:0;height:1.5px;background:#0A2846"></span>
      <span style="position:absolute;left:0;right:0;top:5px;height:1.5px;background:#0A2846"></span>
      <span style="position:absolute;left:0;right:0;top:10px;height:1.5px;background:#0A2846"></span>
    </div>
  </button>
</header>

<!-- ====== HERO ====== -->
<section class="hb-hero" style="background:#0A2846;color:#fff;padding:96px 32px 80px" id="top">
  <div style="position:relative;max-width:1280px;margin:0 auto">
    <div class="hb-hero-badge hb-up is-in" style="color:#5C8FDB">デジタル経理人材プログラム</div>
    <h1 class="hb-hero-display" style="color:#fff">
      <div><span class="hb-chars is-in"><span class="hb-line">未経験から、</span></span></div>
      <div><span class="hb-accent" style="border-bottom-color:#5C8FDB"><span class="hb-chars is-in"><span class="hb-line">クラウド会計の即戦力へ。</span></span></span></div>
    </h1>
    <div class="hb-hero-body" style="margin-top:32px;max-width:680px">
      <p class="hb-up is-in" style="font-size:16px;line-height:1.9;color:rgba(255,255,255,.8);margin:0">
        経理未経験の方・ブランクのある方を、<span style="color:#5C8FDB;font-weight:600">freee会計</span>を扱える<strong style="font-weight:600;color:#fff">「デジタル経理人材」</strong>へ。<br>
        実務スキルの習得から<strong style="font-weight:600;color:#fff">就労マッチングまで一気通貫で支援</strong>します。
      </p>
    </div>
    <div class="hb-hero-actions hb-up is-in" style="margin-top:28px">
      <a href="https://lin.ee/QnI7WzZ" target="_blank" rel="noopener" class="hb-line-btn">公式LINEで説明会を予約 <span class="hb-arrow">→</span></a>
      <a href="https://tol-app.jp/s/hatenabase/62j05r" target="_blank" rel="noopener" class="hb-apply-btn">受講を申し込む <span class="hb-arrow">↗</span></a>
    </div>
    </div>
  </div>
</section>




<!-- CTA DUO (短縮版 #18) -->
<div class="hb-cta-duo" style="background:#fff">
  <div class="hb-cta-duo-inner">
    <div class="hb-cta-duo-col">
      <a href="https://lin.ee/QnI7WzZ" target="_blank" rel="noopener" class="hb-line-btn" style="width:100%;justify-content:center">公式LINEで説明会を予約 <span class="hb-arrow">→</span></a>
    </div>
    <div class="hb-cta-duo-col">
      <a href="https://tol-app.jp/s/hatenabase/62j05r" target="_blank" rel="noopener" class="hb-apply-btn" style="width:100%;justify-content:center">受講を申し込む <span class="hb-arrow">↗</span></a>
    </div>
  </div>
</div>

<!-- ====== PARTNER LOGOS ====== -->
<section style="padding:28px 32px;border-bottom:1px solid var(--hb-border);background:#fff">
  <div class="hb-partner-row" style="max-width:1280px;margin:0 auto">
    <div style="font-family: "Zen Kaku Gothic New", "Hiragino Kaku Gothic ProN", "Noto Sans JP", sans-serif;font-size:10px;letter-spacing:.28em;color:var(--hb-muted);margin-right:24px">パートナー</div>
    <img src="__ASSETS__logo_freee.png" alt="freee" style="height:28px;opacity:.9">
    <img src="__ASSETS__logo_digitalbase.png" alt="DIGITAL BASE" style="height:36px;opacity:.9">
    <img src="__ASSETS__logo_careermom.png" alt="キャリアマム" style="height:32px;opacity:.9">
    <img src="__ASSETS__logo_maia.png" alt="MAIA" style="height:28px;opacity:.9">
    <img src="__ASSETS__logo_primas.png" alt="PRIMAS" style="height:26px;opacity:.9">
  </div>
</section>

<!-- ====== PAIN POINTS ====== -->
<section class="hb-section" style="background:#fff">
  <div class="hb-section-narrow">
    <div class="hb-section-head">
      <span class="hb-section-head-jp"><span class="hb-chars"><span class="hb-line">こんな悩みはありませんか</span></span></span>
    </div>
    <div class="hb-pain-grid">
      <div class="hb-pain-card hb-up">
        <div style="font-family:"Zen Kaku Gothic New", "Hiragino Kaku Gothic ProN", "Noto Sans JP", sans-serif;font-weight:300;font-size:28px;color:var(--hb-blue);margin-bottom:14px">01</div>
        <div style="font-weight:700;font-size:15px;margin-bottom:10px">資格はあるのに実務経験がない</div>
        <p style="font-size:13px;line-height:1.9;color:var(--hb-sub);margin:0">簿記資格はあるが、実務経験を問われて応募できない。</p>
      </div>
      <div class="hb-pain-card hb-up">
        <div style="font-family:"Zen Kaku Gothic New", "Hiragino Kaku Gothic ProN", "Noto Sans JP", sans-serif;font-weight:300;font-size:28px;color:var(--hb-blue);margin-bottom:14px">02</div>
        <div style="font-weight:700;font-size:15px;margin-bottom:10px">クラウド会計ソフトが使えない</div>
        <p style="font-size:13px;line-height:1.9;color:var(--hb-sub);margin:0">freee等の操作経験がなく、求人条件を満たせない。</p>
      </div>
      <div class="hb-pain-card hb-up">
        <div style="font-family:"Zen Kaku Gothic New", "Hiragino Kaku Gothic ProN", "Noto Sans JP", sans-serif;font-weight:300;font-size:28px;color:var(--hb-blue);margin-bottom:14px">03</div>
        <div style="font-weight:700;font-size:15px;margin-bottom:10px">独学では限界を感じている</div>
        <p style="font-size:13px;line-height:1.9;color:var(--hb-sub);margin:0">書籍や動画では、月次決算の実務がイメージできない。</p>
      </div>
      <div class="hb-pain-card hb-up">
        <div style="font-family:"Zen Kaku Gothic New", "Hiragino Kaku Gothic ProN", "Noto Sans JP", sans-serif;font-weight:300;font-size:28px;color:var(--hb-blue);margin-bottom:14px">04</div>
        <div style="font-weight:700;font-size:15px;margin-bottom:10px">子育てしながら働きたい</div>
        <p style="font-size:13px;line-height:1.9;color:var(--hb-sub);margin:0">リモートで働ける経理職に、未経験から就きたい。</p>
      </div>
      <div class="hb-pain-card hb-up">
        <div style="font-family:"Zen Kaku Gothic New", "Hiragino Kaku Gothic ProN", "Noto Sans JP", sans-serif;font-weight:300;font-size:28px;color:var(--hb-blue);margin-bottom:14px">05</div>
        <div style="font-weight:700;font-size:15px;margin-bottom:10px">キャリアブランクがある</div>
        <p style="font-size:13px;line-height:1.9;color:var(--hb-sub);margin:0">育児・介護のブランクで、復職に不安がある。</p>
      </div>
      <div class="hb-pain-card hb-up">
        <div style="font-family:"Zen Kaku Gothic New", "Hiragino Kaku Gothic ProN", "Noto Sans JP", sans-serif;font-weight:300;font-size:28px;color:var(--hb-blue);margin-bottom:14px">06</div>
        <div style="font-weight:700;font-size:15px;margin-bottom:10px">学習方法の選択に迷っている</div>
        <p style="font-size:13px;line-height:1.9;color:var(--hb-sub);margin:0">スクール・通信・独学のどれが合うかわからない。</p>
      </div>
    </div>
  </div>
</section>

<!-- ====== MODEL ====== -->
<section class="hb-section hb-section-alt">
  <div class="hb-section-narrow">
    <div class="hb-section-head">
      <span class="hb-section-head-jp"><span class="hb-chars"><span class="hb-line">研修を受ける → 就労マッチング → フォローアップ</span></span></span>
    </div>
    <p class="hb-up" style="font-size:15px;line-height:2.1;color:#3A3A45;margin:0 0 48px;max-width:680px">
      デジタル経理人材プログラムは、単なるスキル研修ではありません。<br>
      <span style="color:#1F61AB;font-weight:700">「研修 → マッチング → フォローアップ」</span>までを、<br>
      ひとつのプログラムで完結できます。
    </p>
    <div style="display:grid;grid-template-columns:repeat(3,1fr);gap:0;border:1px solid var(--hb-border)">
      <div class="hb-up" style="padding:48px 36px;border-right:1px solid var(--hb-border)">
        <div style="display:flex;align-items:baseline;gap:12px;margin-bottom:28px">
          <span style="font-family:"Zen Kaku Gothic New", "Hiragino Kaku Gothic ProN", "Noto Sans JP", sans-serif;font-weight:300;font-size:42px;color:var(--hb-blue);line-height:1">01</span>
          <span style="font-family: "Zen Kaku Gothic New", "Hiragino Kaku Gothic ProN", "Noto Sans JP", sans-serif;font-size:10px;letter-spacing:.28em;color:var(--hb-muted)"/span>
        </div>
        <h3 style="font-family:'Zen Kaku Gothic New','Noto Sans JP',sans-serif;font-weight:800;font-size:24px;line-height:1.3;margin:0 0 18px">研修を受ける</h3>
        <p style="font-size:13.5px;line-height:2;color:var(--hb-sub);margin:0">eラーニング8時間と実地研修2日間で、模擬月次決算まで実践。freee認定5つ星アドバイザー監修のカリキュラムで学べます。</p>
      </div>
      <div class="hb-up" style="padding:48px 36px;border-right:1px solid var(--hb-border);background:var(--hb-blue-ghost)">
        <div style="display:flex;align-items:baseline;gap:12px;margin-bottom:28px">
          <span style="font-family:"Zen Kaku Gothic New", "Hiragino Kaku Gothic ProN", "Noto Sans JP", sans-serif;font-weight:300;font-size:42px;color:var(--hb-blue);line-height:1">02</span>
          <span style="font-family: "Zen Kaku Gothic New", "Hiragino Kaku Gothic ProN", "Noto Sans JP", sans-serif;font-size:10px;letter-spacing:.28em;color:var(--hb-muted)"/span>
        </div>
        <h3 style="font-family:'Zen Kaku Gothic New','Noto Sans JP',sans-serif;font-weight:800;font-size:24px;line-height:1.3;margin:0 0 18px">就労マッチング</h3>
        <p style="font-size:13.5px;line-height:2;color:var(--hb-sub);margin:0">修了後は提携企業・自社案件・税理士事務所など、希望に合う就労先とマッチング。講師など多様なキャリアパスも選べます。</p>
      </div>
      <div class="hb-up" style="padding:48px 36px">
        <div style="display:flex;align-items:baseline;gap:12px;margin-bottom:28px">
          <span style="font-family:"Zen Kaku Gothic New", "Hiragino Kaku Gothic ProN", "Noto Sans JP", sans-serif;font-weight:300;font-size:42px;color:var(--hb-blue);line-height:1">03</span>
          <span style="font-family: "Zen Kaku Gothic New", "Hiragino Kaku Gothic ProN", "Noto Sans JP", sans-serif;font-size:10px;letter-spacing:.28em;color:var(--hb-muted)"/span>
        </div>
        <h3 style="font-family:'Zen Kaku Gothic New','Noto Sans JP',sans-serif;font-weight:800;font-size:24px;line-height:1.3;margin:0 0 18px">フォローアップ</h3>
        <p style="font-size:13.5px;line-height:2;color:var(--hb-sub);margin:0">就業後1ヶ月間はSlackでフォローアップ。業務の疑問を相談しながら、現場に定着できます。</p>
      </div>
    </div>
  </div>
</section>


<!-- ====== 得られるスキル (#26) ====== -->
<section class="hb-section" style="background:#fff">
  <div class="hb-section-narrow">
    <div class="hb-section-head">
      <span class="hb-section-head-jp"><span class="hb-chars"><span class="hb-line">当プログラムで得られるスキル</span></span></span>
    </div>
    <ul class="hb-skill-list hb-up"><li><span>✓</span>freee会計の基本操作</li><li><span>✓</span>「自動で経理」の活用</li><li><span>✓</span>自動登録ルールの設定</li><li><span>✓</span>日次の記帳代行（一人で完結）</li><li><span>✓</span>月次決算の一連対応</li><li><span>✓</span>仕訳ミスの発見・修正</li><li><span>✓</span>税理士への引き継ぎ対応</li><li><span>✓</span>フルリモートでの経理勤務</li></ul>
    <p class="hb-up" style="font-size:13px;color:var(--hb-blue);font-weight:700;margin:22px 0 0">仕訳の根拠を言語化できる状態まで引き上げます。</p>
  </div>
</section>

<!-- ====== MARKET VALUE (issue#24-9) ====== -->
<section class="hb-section hb-section-alt">
  <div class="hb-section-narrow">
    <div class="hb-section-head">
      <span class="hb-section-head-jp"><span class="hb-chars"><span class="hb-line">スキル習得で広がるキャリアの可能性</span></span></span>
      
    </div>
    <p class="hb-up" style="font-size:14px;line-height:2;color:var(--hb-sub);margin:0 0 36px;max-width:680px">freee対応の経理スキルは、働き方とキャリアの選択肢を広げます。スキル習得による金銭的メリットも、キャリア形成の一部としてご紹介します。</p>
    <div class="hb-income-grid hb-up" style="grid-template-columns:1fr;max-width:760px">
      <div class="hb-income-card">
        <div class="hb-income-tag" style="color:var(--hb-blue)">本プログラムで得られるキャリアアップの可能性</div>
        <p style="font-size:13.5px;line-height:2;color:var(--hb-sub);margin:10px 0 0">一般事務からfreee対応の経理スタッフへ。記帳から月次決算まで対応できるスキルを身につけることで、フルリモート勤務など働き方の選択肢が広がり、待遇面の向上にもつながります。</p>
      </div>
    </div>
    <div class="hb-remote-strip hb-up">経理・財務系のクラウド会計求人のうち <b>51.9%</b> がリモート可<span style="font-size:11px;color:var(--hb-muted)">　※ はてなベース実績・求人情報をもとに作成</span></div>
  </div>
</section>

<!-- ====== PROGRAMS ====== -->
<section id="programs" class="hb-section" style="background:#fff">
  <div style="max-width:1280px;margin:0 auto">
    <div class="hb-section-head">
      <span class="hb-section-head-jp"><span class="hb-chars"><span class="hb-line">研修ラインナップ</span></span></span>
    </div>
    <div class="hb-training-grid">
      <a href="#curriculum" class="hb-training-card hb-up">
        <span class="hb-training-tag individual">受付中</span>
        <div class="hb-training-title">freee会計研修</div>
        <div class="hb-training-desc">eラーニング8h＋実地研修2日間。仕訳入力から月次決算まで全15レッスン。freee認定5つ星アドバイザー監修。デモ環境での模擬月次決算演習付き。</div>
        <div class="hb-training-price">¥100,000</div>
        <div style="font-size:11px;color:var(--hb-sub);margin-top:6px">パートナー: フリー株式会社</div>
        <div class="hb-training-arrow">プログラム詳細 <span class="hb-arrow">↗</span></div>
      </a>
      <a href="https://lin.ee/QnI7WzZ" class="hb-training-card hb-up">
        <span class="hb-training-tag individual">受付中</span>
        <div class="hb-training-title">freee人事労務研修</div>
        <div class="hb-training-desc">freee人事労務の実務オペレーションを短期集中で習得。給与計算・勤怠管理・年末調整など、人事労務の基幹業務をデモ環境で実践的に学びます。</div>
        <div class="hb-training-price">¥100,000</div>
        <div style="font-size:11px;color:var(--hb-sub);margin-top:6px">パートナー: フリー株式会社</div>
        <div class="hb-training-arrow">プログラム詳細 <span class="hb-arrow">↗</span></div>
      </a>
      <a href="https://lin.ee/QnI7WzZ" class="hb-training-card hb-up">
        <span class="hb-training-tag coming">2026年夏 開講予定</span>
        <div class="hb-training-title">マネーフォワード クラウド研修</div>
        <div class="hb-training-desc">eラーニング＋実地研修で、マネーフォワードクラウド会計の実務オペレーションを習得。株式会社マネーフォワードとの連携を準備中。</div>
        <div class="hb-training-price" style="color:var(--hb-muted)">準備中</div>
        <div class="hb-training-arrow" style="color:#06C755">LINEで最新情報を受取る <span class="hb-arrow">↗</span></div>
      </a>
      <a href="https://lin.ee/QnI7WzZ" class="hb-training-card hb-up">
        <span class="hb-training-tag coming">2026年秋 開講予定</span>
        <div class="hb-training-title">勘定奉行クラウド研修</div>
        <div class="hb-training-desc">eラーニング＋ライブ研修（約44h）で、勘定奉行クラウドの実務を習得。</div>
        <div class="hb-training-price" style="color:var(--hb-muted)">準備中</div>
        <div class="hb-training-arrow" style="color:#06C755">LINEで最新情報を受取る <span class="hb-arrow">↗</span></div>
      </a>
    </div>
  </div>
</section>



<!-- ====== PROGRAM OVERVIEW DIAGRAMS (issue#73) ====== -->
<section class="hb-section hb-section-alt">
  <div class="hb-section-narrow">
    <figure class="hb-overview-fig hb-up">
      <img src="__ASSETS__training-3phase-overview.png" alt="速習freee会計研修の全体像 — E-learning・実地研修・就労マッチングの3フェーズ" loading="lazy" width="960">
    </figure>
    <div class="hb-bridge-cap hb-up">
      <p class="hb-bridge-lead">研修だけで、終わらせない。</p>
      <p class="hb-bridge-body">はてなベースは、全国から経理人材を募集し、速習クラウド会計研修で育成。<br>修了後は会計事務所・BPO企業・自社案件への就労マッチングまで一気通貫で支援します。</p>
    </div>
    <figure class="hb-overview-fig hb-up">
      <img src="__ASSETS__training-business-model.png" alt="はてなベースの研修事業モデル — 募集から育成・就労マッチングまでの全体フロー" loading="lazy" width="960">
    </figure>
  </div>
</section>

<!-- ====== CURRICULUM (issue#24-11) ====== -->
<section class="hb-section" style="background:#fff" id="curriculum">
  <div class="hb-section-narrow">
    <div class="hb-section-head">
      <span class="hb-section-head-jp"><span class="hb-chars"><span class="hb-line">eラーニング カリキュラム 全15レッスン</span></span></span>
    </div>
    <p class="hb-up" style="font-size:14px;line-height:2;color:var(--hb-sub);margin:0 0 32px;max-width:680px">freee会計の基本操作から、自動経理・請求書・レポート活用まで。実務で必要なスキルを約8時間の動画で網羅的に学びます。</p>
    <div class="hb-lesson-list"><div class="hb-lesson-row hb-up"><span class="hb-lesson-no">レッスン01</span><span class="hb-lesson-t">freee会計の基本機能</span><span class="hb-lesson-tag">基礎</span></div><div class="hb-lesson-row hb-up"><span class="hb-lesson-no">レッスン02</span><span class="hb-lesson-t">freee会計独自の機能「タグ」という概念</span><span class="hb-lesson-tag">基礎</span></div><div class="hb-lesson-row hb-up"><span class="hb-lesson-no">レッスン03</span><span class="hb-lesson-t">自動で経理 — 自動で経理とは？</span><span class="hb-lesson-tag">自動経理</span></div><div class="hb-lesson-row hb-up"><span class="hb-lesson-no">レッスン04</span><span class="hb-lesson-t">自動で経理 — 取引明細の主な処理パターンと税区分の設定</span><span class="hb-lesson-tag">自動経理</span></div><div class="hb-lesson-row hb-up"><span class="hb-lesson-no">レッスン05</span><span class="hb-lesson-t">自動で経理 — freee人事労務から登録された給与の消込</span><span class="hb-lesson-tag">自動経理</span></div><div class="hb-lesson-row hb-up"><span class="hb-lesson-no">レッスン06</span><span class="hb-lesson-t">自動登録ルール — 自動登録ルールとは？</span><span class="hb-lesson-tag">自動化</span></div><div class="hb-lesson-row hb-up"><span class="hb-lesson-no">レッスン07</span><span class="hb-lesson-t">自動登録ルール — 処理パターンごとの設定と条件設定</span><span class="hb-lesson-tag">自動化</span></div><div class="hb-lesson-row hb-up"><span class="hb-lesson-no">レッスン08</span><span class="hb-lesson-t">自動登録ルール — テンプレートの活用と運用精度の向上</span><span class="hb-lesson-tag">自動化</span></div><div class="hb-lesson-row hb-up"><span class="hb-lesson-no">レッスン09</span><span class="hb-lesson-t">freee請求書の発行と取引登録までの流れ</span><span class="hb-lesson-tag">請求書</span></div><div class="hb-lesson-row hb-up"><span class="hb-lesson-no">レッスン10</span><span class="hb-lesson-t">発行済み請求書の修正と応用的な機能</span><span class="hb-lesson-tag">請求書</span></div><div class="hb-lesson-row hb-up"><span class="hb-lesson-no">レッスン11</span><span class="hb-lesson-t">取引の一覧・登録 — 既存取引の管理と修正</span><span class="hb-lesson-tag">取引管理</span></div><div class="hb-lesson-row hb-up"><span class="hb-lesson-no">レッスン12</span><span class="hb-lesson-t">取引の一覧・登録 — 一括編集とプラス更新</span><span class="hb-lesson-tag">取引管理</span></div><div class="hb-lesson-row hb-up"><span class="hb-lesson-no">レッスン13</span><span class="hb-lesson-t">仕訳の確認方法および月次推移とレポート活用術</span><span class="hb-lesson-tag">レポート</span></div><div class="hb-lesson-row hb-up"><span class="hb-lesson-no">レッスン14</span><span class="hb-lesson-t">連続取引登録を活用した請求書と立替レシートの取引登録</span><span class="hb-lesson-tag">実務応用</span></div><div class="hb-lesson-row hb-up"><span class="hb-lesson-no">レッスン15</span><span class="hb-lesson-t">支払管理レポートを使った総合振込リストの出力</span><span class="hb-lesson-tag">実務応用</span></div></div>
    <figure class="hb-video-fig hb-up">
      <div class="hb-video-cap-head">eラーニング紹介動画</div>
      <video controls preload="none" playsinline style="width:100%;display:block;background:#0A2846" src="https://hatenabase.github.io/hatenabase-freee-training/images/elearning-intro.mp4"></video>
      <figcaption><b>eラーニング内容の紹介</b><br>Notionで管理されたカリキュラム一覧と、受講者が実際に使うeラーニング画面の全体像をまとめた動画です。</figcaption>
    </figure>
  </div>
</section>

<!-- ====== SAMPLE VIDEO (issue#24-5) ====== -->
<section class="hb-section" style="background:#fff" id="sample">
  <div class="hb-section-narrow">
    <div class="hb-section-head">
      <span class="hb-section-head-jp"><span class="hb-chars"><span class="hb-line">eラーニングの参考動画</span></span></span>
    </div>
    <p class="hb-up" style="font-size:14px;line-height:2;color:var(--hb-sub);margin:0 0 32px;max-width:680px">研修のイメージを掴んでいただくため、eラーニングの一部をサンプルとしてご覧いただけます。</p>
    <figure class="hb-video-fig hb-up">
      <video controls preload="none" playsinline style="width:100%;display:block;background:#0A2846" src="https://hatenabase.github.io/hatenabase-freee-training/images/sample-lesson.mp4"></video>
      <figcaption><b>Lesson 4-20: eラーニング サンプル講義</b><br>実際のeラーニングコンテンツの一部をご覧いただけます。研修のイメージを掴んでいただくためのサンプルです。</figcaption>
    </figure>
  </div>
</section>

<!-- ====== SCHEDULE 実地2日間 (issue#24-11) ====== -->
<section class="hb-section hb-section-alt" id="schedule2days">
  <div class="hb-section-narrow">
    <div class="hb-section-head">
      <span class="hb-section-head-jp"><span class="hb-chars"><span class="hb-line">バーチャル月次決算 2日間のスケジュール</span></span></span>
    </div>
    <p class="hb-up" style="font-size:14px;line-height:2;color:var(--hb-sub);margin:0 0 32px;max-width:720px">eラーニングだけでは実務レベルには到達しません。freeeデモ環境と仮想経理部長のもと、仮想企業の月次決算を2日間かけて実際に回します。</p>
    <div class="hb-tt-block hb-up"><div class="hb-tt-day">1日目 — 取引整理・仕訳</div><table class="hb-tt-table"><thead><tr><th>時間</th><th>内容</th><th>詳細</th></tr></thead><tbody><tr><td class="hb-tt-time">09:30–10:00</td><td class="hb-tt-topic">開講式・チームビルディング</td><td class="hb-tt-detail">合宿全体の流れを説明し、受講者同士の交流を促します。3〜4名ごとのグループを編成。</td></tr><tr><td class="hb-tt-time">10:00–12:00</td><td class="hb-tt-topic">eラーニング重要ポイント解説</td><td class="hb-tt-detail">事前学習でつまずきやすいポイントを講師が改めて解説。疑問点を解消します。</td></tr><tr><td class="hb-tt-time">12:00–13:00</td><td class="hb-tt-topic">休憩</td><td class="hb-tt-detail">—</td></tr><tr><td class="hb-tt-time">13:00–15:00</td><td class="hb-tt-topic">バーチャル月次決算（前半）</td><td class="hb-tt-detail">講師の指導のもと、仮想の会社で実際の月次決算業務を開始。最初の「トラップ」が仕込まれています。</td></tr><tr><td class="hb-tt-time">15:15–17:00</td><td class="hb-tt-topic">グループワーク・演習</td><td class="hb-tt-detail">各グループで協力しながら、前半の月次決算を完了。講師は巡回して個別にアドバイス。</td></tr><tr><td class="hb-tt-time">17:00–18:00</td><td class="hb-tt-topic">振り返り・質疑応答</td><td class="hb-tt-detail">学んだことをグループで共有し、講師への全体質疑応答で知識を定着させます。</td></tr></tbody></table></div>
    <div class="hb-tt-block hb-up"><div class="hb-tt-day">2日目 — 月次決算・修了</div><table class="hb-tt-table"><thead><tr><th>時間</th><th>内容</th><th>詳細</th></tr></thead><tbody><tr><td class="hb-tt-time">09:30–10:00</td><td class="hb-tt-topic">前日の復習</td><td class="hb-tt-detail">前日の演習内容を振り返り、グループ内で進捗を確認。</td></tr><tr><td class="hb-tt-time">10:00–12:00</td><td class="hb-tt-topic">バーチャル月次決算（後半）</td><td class="hb-tt-detail">より複雑な「トラップ」を攻略し、難易度の高い取引の仕訳・計上を実践。</td></tr><tr><td class="hb-tt-time">12:00–13:00</td><td class="hb-tt-topic">休憩</td><td class="hb-tt-detail">—</td></tr><tr><td class="hb-tt-time">13:00–14:30</td><td class="hb-tt-topic">最終演習</td><td class="hb-tt-detail">演習内容を総動員し、決算の最終チェックと確認作業。</td></tr><tr><td class="hb-tt-time">14:45–16:45</td><td class="hb-tt-topic">修了テスト</td><td class="hb-tt-detail">合宿の集大成として、freeeの実務能力を問う実践形式のテスト。</td></tr><tr><td class="hb-tt-time">16:45–17:30</td><td class="hb-tt-topic">講評・キャリア相談</td><td class="hb-tt-detail">テストのポイント解説と合宿全体の講評。就労先についてもご案内。</td></tr><tr><td class="hb-tt-time">17:30–18:00</td><td class="hb-tt-topic">閉講式・修了証授与</td><td class="hb-tt-detail">合格者には修了証を授与し、今後のキャリアサポートについて説明。</td></tr></tbody></table></div>
  </div>
</section>


<!-- ====== INSTRUCTORS (issue#24-12) ====== -->
<section class="hb-section hb-section-alt" id="instructors">
  <div class="hb-section-narrow">
    <div class="hb-section-head">
      <span class="hb-section-head-jp"><span class="hb-chars"><span class="hb-line">会計ソフトに精通した専門家がサポート</span></span></span>
    </div>
    <p class="hb-up" style="font-size:14px;line-height:2;color:var(--hb-sub);margin:0 0 36px;max-width:720px">freeeの導入・運用支援で多数の実績を持つ専門家が直接講義。机上の会計理論ではなく、freeeを使った実務で本当に起きる判断を、現場目線から伝えます。</p>
    <div class="hb-ins-grid">
      <div class="hb-ins-card hb-up">
        <div class="hb-ins-photo"><img src="__ASSETS__seto-profile.jpg" alt="世戸口 逸人" loading="lazy"></div>
        <div class="hb-ins-body">
          <div class="hb-ins-name">世戸口 逸人 <span>せとぐち はやと</span></div>
          <div class="hb-ins-title">はてなベース株式会社 代表取締役 ／ 公認会計士試験合格者</div>
          <p>はてなベース株式会社を創業。freee会計を軸としたバックオフィスDX支援と、即戦力経理人材の育成に取り組む。freeeとの業務提携のもと『速習freee会計研修』を開発し、クラウド会計の即戦力人材を輩出。上場企業から創業期まで、AIエージェントを活用した自律型バックオフィスの設計を手がける。</p>
          <div class="hb-ins-badges"><span>一般社団法人DIGITALBASE 理事</span><span>freee認定アドバイザー</span></div>
        </div>
      </div>
      <div class="hb-ins-card hb-up">
        <div class="hb-ins-photo"><img src="__ASSETS__tamura-profile.jpg" alt="田村 直大" loading="lazy"></div>
        <div class="hb-ins-body">
          <div class="hb-ins-name">田村 直大 <span>たむら なおひろ</span></div>
          <div class="hb-ins-title">税理士 ／ 公認会計士</div>
          <p>税理士事務所の会計ソフトをfreee会計100%で運用。スタートアップから中堅企業まで幅広い業種の会計・税務を日々支援。「クラウド会計を導入したが、運用が回っていない」企業の立て直しを数多く経験。研修では、freeeの自動化が効く場面と、人間が判断すべき場面の見極めを中心に教える。</p>
          <div class="hb-ins-badges"><span>公認会計士</span><span>税理士</span></div>
        </div>
      </div>
    </div>
  </div>
</section>

<!-- ====== FLOW ====== -->
<section id="flow" class="hb-section hb-section-alt">
  <div style="max-width:1280px;margin:0 auto">
    <div class="hb-section-head">
      <span class="hb-section-head-jp"><span class="hb-chars"><span class="hb-line">登録から就労まで、およそ6週間</span></span></span>
    </div>
    <div class="hb-step-grid">
      <div class="hb-step-card hb-up">
        <div style="font-family:"Zen Kaku Gothic New", "Hiragino Kaku Gothic ProN", "Noto Sans JP", sans-serif;font-weight:300;font-size:36px;color:var(--hb-blue);line-height:1;margin-bottom:18px">01</div>
        <div style="font-family: "Zen Kaku Gothic New", "Hiragino Kaku Gothic ProN", "Noto Sans JP", sans-serif;font-size:10px;letter-spacing:.22em;color:var(--hb-muted);margin-bottom:8px">10秒</div>
        <h3 style="font-weight:700;font-size:16px;margin:0 0 12px">公式LINE登録</h3>
        <p style="font-size:12.5px;line-height:1.85;color:var(--hb-sub);margin:0">研修スケジュール・説明会案内・キャリア情報をお届け。</p>
      </div>
      <div class="hb-step-card hb-up">
        <div style="font-family:"Zen Kaku Gothic New", "Hiragino Kaku Gothic ProN", "Noto Sans JP", sans-serif;font-weight:300;font-size:36px;color:var(--hb-blue);line-height:1;margin-bottom:18px">02</div>
        <div style="font-family: "Zen Kaku Gothic New", "Hiragino Kaku Gothic ProN", "Noto Sans JP", sans-serif;font-size:10px;letter-spacing:.22em;color:var(--hb-muted);margin-bottom:8px">15〜30分</div>
        <h3 style="font-weight:700;font-size:16px;margin:0 0 12px">無料カウンセリング</h3>
        <p style="font-size:12.5px;line-height:1.85;color:var(--hb-sub);margin:0">キャリア目標のヒアリングと最適なコースのご提案。オンラインで実施。</p>
      </div>
      <div class="hb-step-card hb-up" style="background:var(--hb-blue-ghost)">
        <div style="font-family:"Zen Kaku Gothic New", "Hiragino Kaku Gothic ProN", "Noto Sans JP", sans-serif;font-weight:300;font-size:36px;color:var(--hb-blue);line-height:1;margin-bottom:18px">03</div>
        <div style="font-family: "Zen Kaku Gothic New", "Hiragino Kaku Gothic ProN", "Noto Sans JP", sans-serif;font-size:10px;letter-spacing:.22em;color:var(--hb-muted);margin-bottom:8px">約8時間</div>
        <h3 style="font-weight:700;font-size:16px;margin:0 0 12px">eラーニング受講</h3>
        <p style="font-size:12.5px;line-height:1.85;color:var(--hb-sub);margin:0">1ヶ月間視聴可能。Slackでの質問対応付き。自分のペースで進められます。</p>
      </div>
      <div class="hb-step-card hb-up">
        <div style="font-family:"Zen Kaku Gothic New", "Hiragino Kaku Gothic ProN", "Noto Sans JP", sans-serif;font-weight:300;font-size:36px;color:var(--hb-blue);line-height:1;margin-bottom:18px">04</div>
        <div style="font-family: "Zen Kaku Gothic New", "Hiragino Kaku Gothic ProN", "Noto Sans JP", sans-serif;font-size:10px;letter-spacing:.22em;color:var(--hb-muted);margin-bottom:8px">2日間</div>
        <h3 style="font-weight:700;font-size:16px;margin:0 0 12px">実地研修</h3>
        <p style="font-size:12.5px;line-height:1.85;color:var(--hb-sub);margin:0">デモ環境で模擬月次決算を体験。Zoom参加も可能。</p>
      </div>
      <div class="hb-step-card hb-up">
        <div style="font-family:"Zen Kaku Gothic New", "Hiragino Kaku Gothic ProN", "Noto Sans JP", sans-serif;font-weight:300;font-size:36px;color:var(--hb-blue);line-height:1;margin-bottom:18px">05</div>
        <div style="font-family: "Zen Kaku Gothic New", "Hiragino Kaku Gothic ProN", "Noto Sans JP", sans-serif;font-size:10px;letter-spacing:.22em;color:var(--hb-muted);margin-bottom:8px">＋6か月</div>
        <h3 style="font-weight:700;font-size:16px;margin:0 0 12px">就労マッチング</h3>
        <p style="font-size:12.5px;line-height:1.85;color:var(--hb-sub);margin:0">マッチング面談を実施。就業後は1ヶ月間フォローアップ。</p>
      </div>
    </div>
  </div>
</section>

<!-- ====== CAREER ====== -->
<section id="career" class="hb-vision" style="background:#1F61AB">
  <div class="hb-vision-inner">
    <div>
      <div class="hb-up" style="font-family: "Zen Kaku Gothic New", "Hiragino Kaku Gothic ProN", "Noto Sans JP", sans-serif;font-size:11px;font-weight:500;letter-spacing:.32em;opacity:.85;margin-bottom:32px;display:flex;align-items:center;gap:10px"><span style="display:inline-block;width:8px;height:8px;border-radius:50%;background:#fff"></span>キャリアパス</div>
      <h2 class="hb-vision-display" style="font-size:clamp(48px,7vw,96px)">
        <div><span class="hb-chars is-in"><span class="hb-line">研修修了後、</span></span></div>
        <div style="padding-left:.3em"><span class="hb-chars is-in"><span class="hb-line">キャリアが</span></span></div>
        <div style="padding-left:.5em"><span class="hb-chars is-in"><span class="hb-line">広がる。</span></span></div>
      </h2>
    </div>
    <div>
      <div class="hb-career-grid" style="border-color:rgba(255,255,255,.2)">
        <div class="hb-career-card hb-up" style="border-color:rgba(255,255,255,.2)">
          <div style="font-family:"Zen Kaku Gothic New", "Hiragino Kaku Gothic ProN", "Noto Sans JP", sans-serif;font-weight:300;font-size:28px;color:rgba(255,255,255,.6);margin-bottom:14px">01</div>
          <h4 style="font-size:15px;font-weight:700;margin:0 0 10px;color:#fff">リモート経理スタッフ</h4>
          <p style="font-size:12px;line-height:1.8;color:rgba(255,255,255,.7);margin:0">フルリモート・柔軟な働き方に対応</p>
        </div>
        <div class="hb-career-card hb-up" style="border-color:rgba(255,255,255,.2);background:rgba(255,255,255,.06)">
          <div style="font-family:"Zen Kaku Gothic New", "Hiragino Kaku Gothic ProN", "Noto Sans JP", sans-serif;font-weight:300;font-size:28px;color:rgba(255,255,255,.6);margin-bottom:14px">02</div>
          <h4 style="font-size:15px;font-weight:700;margin:0 0 10px;color:#fff">税理士事務所スタッフ</h4>
          <div style="font-family:Zen Kaku Gothic New,sans-serif;font-size:14px;font-weight:600;color:#fff;margin-bottom:10px">¥200,000〜<small style="font-size:10px;opacity:.7">/月</small></div>
          <p style="font-size:12px;line-height:1.8;color:rgba(255,255,255,.7);margin:0">税務知見の習得機会あり</p>
        </div>
        <div class="hb-career-card hb-up" style="border-color:rgba(255,255,255,.2)">
          <div style="font-family:"Zen Kaku Gothic New", "Hiragino Kaku Gothic ProN", "Noto Sans JP", sans-serif;font-weight:300;font-size:28px;color:rgba(255,255,255,.6);margin-bottom:14px">03</div>
          <h4 style="font-size:15px;font-weight:700;margin:0 0 10px;color:#fff">BPO案件スタッフ</h4>
          <div style="font-family:Zen Kaku Gothic New,sans-serif;font-size:14px;font-weight:600;color:#fff;margin-bottom:10px">¥30,000〜<small style="font-size:10px;opacity:.7">/社</small></div>
          <p style="font-size:12px;line-height:1.8;color:rgba(255,255,255,.7);margin:0">複数社の経験値を蓄積</p>
        </div>
        <div class="hb-career-card hb-up" style="border-color:rgba(255,255,255,.2)">
          <div style="font-family:"Zen Kaku Gothic New", "Hiragino Kaku Gothic ProN", "Noto Sans JP", sans-serif;font-weight:300;font-size:28px;color:rgba(255,255,255,.6);margin-bottom:14px">04</div>
          <h4 style="font-size:15px;font-weight:700;margin:0 0 10px;color:#fff">研修講師</h4>
          <div style="font-family: "Zen Kaku Gothic New", "Hiragino Kaku Gothic ProN", "Noto Sans JP", sans-serif;font-size:11px;font-weight:600;color:rgba(255,255,255,.85);margin-bottom:10px;letter-spacing:.12em">講師</div>
          <p style="font-size:12px;line-height:1.8;color:rgba(255,255,255,.7);margin:0">freee研修やクラウド会計研修の講師として活躍</p>
        </div>
      </div>
    </div>
  </div>
</section>

<!-- ====== 就労先パートナー ====== -->
<section class="hb-section" style="background:#fff">
  <div class="hb-section-narrow">
    <div class="hb-section-head">
      <span class="hb-section-head-jp"><span class="hb-chars"><span class="hb-line">研修修了者の就労先</span></span></span>
    </div>
    <a href="#" class="hb-svc-block hb-up">
      <span class="hb-svc-num">01</span>
      <div>
        <div style="font-family: "Zen Kaku Gothic New", "Hiragino Kaku Gothic ProN", "Noto Sans JP", sans-serif;font-size:10px;letter-spacing:.28em;color:#8A8A93;margin-bottom:6px">協業BPO</div>
        <h3 style="font-family:'Zen Kaku Gothic New','Noto Sans JP',sans-serif;font-weight:700;font-size:22px;margin:0 0 10px">協業パートナー（BPO会社）</h3>
        <p style="font-size:13.5px;line-height:1.85;color:#3A3A45;margin:0">オンライン経理アウトソーシングの提携企業。フルリモートで柔軟な働き方が可能。</p>
      </div>
      <span class="hb-arrow" style="font-size:24px;color:#1F61AB">→</span>
    </a>
    <a href="#" class="hb-svc-block hb-up">
      <span class="hb-svc-num">02</span>
      <div>
        <div style="font-family: "Zen Kaku Gothic New", "Hiragino Kaku Gothic ProN", "Noto Sans JP", sans-serif;font-size:10px;letter-spacing:.28em;color:#8A8A93;margin-bottom:6px">自社・PMO案件</div>
        <h3 style="font-family:'Zen Kaku Gothic New','Noto Sans JP',sans-serif;font-weight:700;font-size:22px;margin:0 0 10px">はてなベース株式会社（PMO案件など）</h3>
        <p style="font-size:13.5px;line-height:1.85;color:#3A3A45;margin:0">はてなベースが請け負うPMO案件等で実務経験を積みながら収入を得られます。</p>
      </div>
      <span class="hb-arrow" style="font-size:24px;color:#1F61AB">→</span>
    </a>
    <a href="#" class="hb-svc-block hb-up">
      <span class="hb-svc-num">03</span>
      <div>
        <div style="font-family: "Zen Kaku Gothic New", "Hiragino Kaku Gothic ProN", "Noto Sans JP", sans-serif;font-size:10px;letter-spacing:.28em;color:#8A8A93;margin-bottom:6px">税理士事務所</div>
        <h3 style="font-family:'Zen Kaku Gothic New','Noto Sans JP',sans-serif;font-weight:700;font-size:22px;margin:0 0 10px">はてなベース税理士法人</h3>
        <p style="font-size:13.5px;line-height:1.85;color:#3A3A45;margin:0">freee5つ星認定の税理士事務所。月次決算3営業日で完了する体制。</p>
      </div>
      <span class="hb-arrow" style="font-size:24px;color:#1F61AB">→</span>
    </a>
    <a href="#" class="hb-svc-block hb-up" style="border-bottom:none">
      <span class="hb-svc-num">04</span>
      <div>
        <div style="font-family: "Zen Kaku Gothic New", "Hiragino Kaku Gothic ProN", "Noto Sans JP", sans-serif;font-size:10px;letter-spacing:.28em;color:#8A8A93;margin-bottom:6px">講師への道</div>
        <h3 style="font-family:'Zen Kaku Gothic New','Noto Sans JP',sans-serif;font-weight:700;font-size:22px;margin:0 0 10px">freee研修・クラウド会計研修の講師への道</h3>
        <p style="font-size:13.5px;line-height:1.85;color:#3A3A45;margin:0">研修修了後、実務経験を積んだ先に講師としてのキャリアパスが広がります。後輩育成を通じてさらなるスキルアップが可能。</p>
      </div>
      <span class="hb-arrow" style="font-size:24px;color:#1F61AB">→</span>
    </a>
  </div>
</section>

<!-- ====== 実績 (issue#24-6 差替) ====== -->
<section class="hb-section hb-section-alt">
  <div class="hb-section-narrow">
    <div class="hb-section-head">
      <span class="hb-section-head-jp"><span class="hb-chars"><span class="hb-line">過去の取り組み事例</span></span></span>
      
    </div>
    <div class="hb-case-thumb-grid">
      <a class="hb-case-thumb-card hb-up" href="https://prtimes.jp/main/html/rd/p/000000010.000168081.html" target="_blank" rel="noopener">
        <div class="hb-case-thumb"><img src="__ASSETS__case-prtimes.png" alt="キャリア・マム × はてなベース × freee プレスリリース" loading="lazy"></div>
        <div class="hb-case-thumb-body">
          <div class="hb-case-thumb-tag">プレスリリース</div>
          <div class="hb-case-thumb-t">キャリア・マム × はてなベース × freee「速習freee会計研修（実地研修版）」提供開始</div>
          <div class="hb-case-thumb-link">prtimes.jp ↗</div>
        </div>
      </a>
      <a class="hb-case-thumb-card hb-up" href="https://adv.freee.co.jp/seminar/cloud-accounting-employment" target="_blank" rel="noopener">
        <div class="hb-case-thumb"><img src="__ASSETS__case-seminar-employment.png" alt="クラウド会計 習得済み人材採用セミナー" loading="lazy"></div>
        <div class="hb-case-thumb-body">
          <div class="hb-case-thumb-tag">セミナー</div>
          <div class="hb-case-thumb-t">共催セミナー — クラウド会計 習得済み人材採用で実現する「育成コストゼロ」経営セミナー</div>
          <div class="hb-case-thumb-link">adv.freee.co.jp ↗</div>
        </div>
      </a>
      <a class="hb-case-thumb-card hb-up" href="https://adv.freee.co.jp/seminar/digital-base" target="_blank" rel="noopener">
        <div class="hb-case-thumb"><img src="__ASSETS__case-seminar-digitalbase.png" alt="freee人材育成セミナー" loading="lazy"></div>
        <div class="hb-case-thumb-body">
          <div class="hb-case-thumb-tag">セミナー</div>
          <div class="hb-case-thumb-t">共催セミナー — デジタル時代の会計業界で即戦力になる「freee人材」育成セミナー</div>
          <div class="hb-case-thumb-link">adv.freee.co.jp ↗</div>
        </div>
      </a>
      <a class="hb-case-thumb-card hb-up" href="https://peatix.com/group/16487059/events" target="_blank" rel="noopener">
        <div class="hb-case-thumb"><img src="__ASSETS__case-peatix.png" alt="Peatixセミナー開催情報" loading="lazy"></div>
        <div class="hb-case-thumb-body">
          <div class="hb-case-thumb-tag">セミナー</div>
          <div class="hb-case-thumb-t">Peatixでセミナー開催中 — 最新の開催情報はこちら</div>
          <div class="hb-case-thumb-link">peatix.com ↗</div>
        </div>
      </a>
    </div>
  </div>
</section>

<!-- ====== 受講者の声 (issue#24-7 詳細化) ====== -->
<section class="hb-section" style="background:#fff" id="voices">
  <div class="hb-section-narrow">
    <div class="hb-section-head">
      <span class="hb-section-head-jp"><span class="hb-chars"><span class="hb-line">受講者と現場の声</span></span></span>
      
    </div>
    <p class="hb-up" style="font-size:14px;line-height:2;color:var(--hb-sub);margin:0 0 36px;max-width:720px">未経験からの育成事例、現役経理のリスキリング、子育て中の復帰事例 — 修了後に実際に働き始めた方々の声をご紹介します。</p>

    <div class="hb-voice-card hb-up">
      <div class="hb-voice-head"><span class="hb-voice-case">事例 01 — 簿記2級 × 子育て中 → フルリモート経理</span><span class="hb-voice-who">Mさん（34歳・島根県在住）</span></div>
      <div class="hb-voice-t">子育てしながらリモート経理へキャリアチェンジ</div>
      <p class="hb-voice-p">簿記2級は持っていましたが、freeeの実務経験はゼロ。子どもが幼稚園に通っている間にeラーニングを進め、実地研修では月次決算の一連の流れを演習で体験しました。研修修了後は「自動で経理」や「自動登録ルール」を使った記帳代行が一人でできるレベルに。就労マッチング面談を経て、BPO企業のリモート経理スタッフとして稼働を開始。島根の自宅から、フルリモートで勤務しています。時給はおよそ¥1,400から¥2,000に上がりました。</p>
      <div class="hb-voice-skill-block"><div class="hb-voice-skill-t">この研修でできるようになったこと</div><ul class="hb-skill-list hb-skill-list-sm"><li><span>✓</span>freee会計の基本操作</li><li><span>✓</span>「自動で経理」の活用</li><li><span>✓</span>自動登録ルールの設定</li><li><span>✓</span>日次の記帳代行</li><li><span>✓</span>月次決算の一連対応</li><li><span>✓</span>リモートでの経理勤務</li></ul></div>
    </div>

    <div class="hb-voice-card hb-up">
      <div class="hb-voice-head"><span class="hb-voice-case">事例 02 — 経理ブランク5年 × 育児復帰 → 税理士事務所スタッフ</span><span class="hb-voice-who">Tさん（42歳・東京都在住）</span></div>
      <div class="hb-voice-t">5年のブランクから、税理士事務所の即戦力へ</div>
      <p class="hb-voice-p">出産前は事業会社で経理を3年担当していましたが、育児で5年のブランクがありました。eラーニングで自分のペースで学び直し、実地研修のバーチャル月次決算では「トラップ」として仕込まれた仕訳ミスを見つける演習で実務感覚を取り戻せました。修了後の就労マッチング面談で、freeeをメイン会計ソフトとして使う税理士事務所を紹介いただき、週4日・時短リモートで記帳代行と月次チェックを担当しています。</p>
      <div class="hb-voice-compare">
        <div class="hb-voice-cb"><div class="hb-voice-cb-tag">受講前の想定年収</div><div class="hb-voice-cb-val">¥300<small>万円</small></div><div class="hb-voice-cb-note">ブランク後の想定年収</div></div>
        <div class="hb-voice-cb-arrow">→<span>+¥150万円 / 年 UP</span></div>
        <div class="hb-voice-cb hb-voice-cb-after"><div class="hb-voice-cb-tag">受講後の年収</div><div class="hb-voice-cb-val">¥450<small>万円</small></div><div class="hb-voice-cb-note">税理士事務所からの提示額</div></div>
      </div>
      <div class="hb-voice-skill-block"><div class="hb-voice-skill-t">この研修でできるようになったこと</div><ul class="hb-skill-list hb-skill-list-sm"><li><span>✓</span>freee会計の基本操作</li><li><span>✓</span>「自動で経理」の活用</li><li><span>✓</span>自動登録ルールの設定</li><li><span>✓</span>日次の記帳代行</li><li><span>✓</span>月次決算チェック</li><li><span>✓</span>仕訳ミスの発見・修正</li><li><span>✓</span>税理士への引き継ぎ対応</li><li><span>✓</span>リモートでの経理勤務</li></ul></div>
    </div>

    <div class="hb-up" style="margin:36px 0 18px;font-size:13px;font-weight:700;color:var(--hb-blue);letter-spacing:.06em;border-left:3px solid var(--hb-blue);padding-left:12px">受け入れ企業の声</div>
    <div class="hb-voice-card hb-up">
      <div class="hb-voice-head"><span class="hb-voice-case">受け入れ企業の声 — はてなベース株式会社</span><span class="hb-voice-who">Iさん（23歳）</span></div>
      <div class="hb-voice-t">3ヶ月で実戦の核へ</div>
      <p class="hb-voice-p">未経験でしたが、入社初日からfreeeでの記帳代行をスムーズに開始。3ヶ月目には決算補助まで任せられるレベルになりました。教育に取られていた私の時間はほぼゼロになりました。<span class="hb-voice-by">— 会計事業部 部長</span></p>
    </div>
  </div>
</section>

<!-- ====== PRICING ====== -->
<section id="pricing" class="hb-section hb-section-alt">
  <div class="hb-section-narrow">
    <div class="hb-section-head">
      <span class="hb-section-head-jp"><span class="hb-chars"><span class="hb-line">料金プラン</span></span></span>
    </div>
    <table class="hb-price-table hb-up">
      <thead>
        <tr>
          <th>コース</th>
          <th>料金</th>
          <th>内容</th>
          <th>ステータス</th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td style="font-weight:700">freee会計研修</td>
          <td style="font-family:Zen Kaku Gothic New,sans-serif;font-weight:600;color:var(--hb-blue)">¥100,000</td>
          <td>eラーニング 8h + 実地研修 2日間 + Slackフォロー 1ヶ月</td>
          <td><span class="hb-training-tag individual" style="margin:0">提供中</span></td>
        </tr>
        <tr>
          <td style="font-weight:700">freee人事労務研修</td>
          <td style="font-family:Zen Kaku Gothic New,sans-serif;font-weight:600;color:var(--hb-blue)">¥100,000</td>
          <td>給与計算・勤怠管理・年末調整の実務 + Slackフォロー 1ヶ月</td>
          <td><span class="hb-training-tag individual" style="margin:0">提供中</span></td>
        </tr>
        <tr>
          <td style="font-weight:700">マネーフォワード研修</td>
          <td style="color:var(--hb-muted)">準備中</td>
          <td>eラーニング + 実地研修（詳細準備中）</td>
          <td><span class="hb-training-tag coming" style="margin:0">2026年夏</span></td>
        </tr>
        <tr>
          <td style="font-weight:700">勘定奉行クラウド研修</td>
          <td style="color:var(--hb-muted)">準備中</td>
          <td>eラーニング + ライブ研修（約44h）</td>
          <td><span class="hb-training-tag coming" style="margin:0">2026年秋</span></td>
        </tr>
      </tbody>
    </table>
    <div class="hb-up" style="margin-top:28px;padding:24px 28px;border:1px solid var(--hb-border)">
      <div style="font-family: "Zen Kaku Gothic New", "Hiragino Kaku Gothic ProN", "Noto Sans JP", sans-serif;font-size:10px;letter-spacing:.22em;color:var(--hb-muted);margin-bottom:12px">受講料に含まれるもの</div>
      <div style="display:grid;grid-template-columns:repeat(3,1fr);gap:8px;font-size:13px;color:var(--hb-sub)">
        <div>- eラーニング動画（1ヶ月視聴可能）</div>
        <div>- デモ環境アクセス</div>
        <div>- 実地研修（2日間）</div>
        <div>- Slackサポート（1ヶ月）</div>
        <div>- 就労マッチング</div>
        <div>- 修了証発行</div>
      </div>
    </div>
  </div>
    <div class="hb-up" style="margin-top:40px"><div class="hb-guarantee" style="max-width:640px;margin:0 auto;text-align:left">
        <div class="hb-guarantee-t">🛡 研修内容 全額返金保証</div>
        <p>eラーニング全15レッスンと2日間の実地研修をすべて修了された方には、就労・派遣先のご案内をいたします。万が一、研修内容にご満足いただけなかった場合は、受講料を全額返金いたします。<br><span>※ 返金をご希望の場合は、研修修了後14日以内にお申し出ください。</span></p>
      </div></div>
    </div>
</section>

<!-- ====== FAQ (issue#24-10 参考LP7問移植) ====== -->
<section class="hb-section" style="background:#fff" id="faq">
  <div class="hb-section-narrow">
    <div class="hb-section-head">
      <span class="hb-section-head-jp"><span class="hb-chars"><span class="hb-line">よくあるご質問</span></span></span>
    </div>
    <div style="max-width:840px">
      <div class="hb-faq-item hb-up">
        <div class="hb-faq-q"><span class="hb-faq-badge">Q1</span>経理未経験でも受講できますか？</div>
        <div class="hb-faq-a">はい、未経験の方でも受講いただけます。eラーニングでfreee会計の基本操作から丁寧に学べるカリキュラムです。ただし、日商簿記3級程度の基礎知識があるとよりスムーズに進められます。</div>
      </div>
      <div class="hb-faq-item hb-up">
        <div class="hb-faq-q"><span class="hb-faq-badge">Q2</span>eラーニングはいつでも受講できますか？</div>
        <div class="hb-faq-a">はい、オンデマンド形式の動画コンテンツですので、お好きな時間にご自身のペースで進められます。受講期限までに約8時間分のコンテンツを完了していただきます。</div>
      </div>
      <div class="hb-faq-item hb-up">
        <div class="hb-faq-q"><span class="hb-faq-badge">Q3</span>実地研修はオンラインで参加できますか？</div>
        <div class="hb-faq-a">はい、バーチャル月次決算プログラムはオンラインでの参加が可能です。freeeのデモ環境を使った実技研修のため、ご自宅のPCとインターネット環境があれば受講できます。</div>
      </div>
      <div class="hb-faq-item hb-up">
        <div class="hb-faq-q"><span class="hb-faq-badge">Q4</span>修了後の就労先は保証されますか？</div>
        <div class="hb-faq-a">特定の就労先を保証するものではありませんが、修了者全員に複数の提携企業・会計事務所への就労先候補をご紹介します。freee会計のスキルを持つ人材は業界で非常にニーズが高く、多くの修了者が就労先を見つけています。</div>
      </div>
      <div class="hb-faq-item hb-up">
        <div class="hb-faq-q"><span class="hb-faq-badge">Q5</span>受講に必要なものはありますか？</div>
        <div class="hb-faq-a">ご自身のPC（Windows/Mac）とインターネット環境が必要です。freeeのデモ環境は研修側で用意します。研修前にNDA（秘密保持契約）への締結をお願いしています。</div>
      </div>
      <div class="hb-faq-item hb-up">
        <div class="hb-faq-q"><span class="hb-faq-badge">Q6</span>研修中に使うツールは何ですか？</div>
        <div class="hb-faq-a">freee会計のデモ環境（本番同等の機能）と、コミュニケーションツールとしてSlackを使用します。Slackでは講師への質問や受講者同士の交流が行えます。</div>
      </div>
      <div class="hb-faq-item hb-up">
        <div class="hb-faq-q"><span class="hb-faq-badge">Q7</span>申し込みから研修開始までの流れを教えてください</div>
        <div class="hb-faq-a">申込フォームからエントリー → NDA締結 → freeeデモ環境のアカウント発行 → eラーニング受講開始 → 実地研修（バーチャル月次決算）という流れです。</div>
      </div>
    </div>
  </div>
</section>

<!-- ====== CTA (#18/#19 整理) ====== -->
<section id="contact" class="hb-cta-section">
  <div style="position:relative;max-width:880px;margin:0 auto;text-align:center">
    <h2 class="hb-hero-display" style="margin:0 0 20px;color:#fff;font-size:clamp(28px,4.2vw,44px)">
      <div>クラウド会計のお役立ち情報を</div>
      <div style="color:rgba(255,255,255,.78)">公式LINEでお届けします</div>
    </h2>
    <p class="hb-up" style="font-size:15px;line-height:2;color:rgba(255,255,255,.85);margin:0 auto 32px;max-width:560px">公式LINEは、クラウド会計に関するお役立ち情報を受け取れる場です。説明会のご案内もLINEでお知らせします。</p>
    <div style="display:flex;flex-wrap:wrap;gap:16px;justify-content:center">
      <a href="https://lin.ee/QnI7WzZ" target="_blank" rel="noopener" class="hb-line-btn" style="font-size:15px;padding:16px 30px">公式LINEに登録する <span class="hb-arrow">→</span></a>
      <a href="https://tol-app.jp/s/hatenabase/62j05r" target="_blank" rel="noopener" class="hb-apply-btn hb-apply-btn-inverse" style="font-size:15px;padding:16px 30px">受講を申し込む <span class="hb-arrow">↗</span></a>
    </div>
    <a href="/schedule/" style="display:inline-block;margin-top:28px;font-size:12.5px;color:rgba(255,255,255,.75);text-decoration:underline">企業様向け：人材受け入れのご相談（日程調整） ↗</a>
  </div>
</section>

<!-- ====== GROUP + FOOTER (issue#24-17/33: 本体サイトと統一) ====== -->
<section style="background:#0A2846;color:#fff;padding:72px 32px 0">
  <div style="max-width:1280px;margin:0 auto">
    <div style="font-family:"Zen Kaku Gothic New", "Hiragino Kaku Gothic ProN", "Noto Sans JP", sans-serif;font-weight:300;font-size:clamp(40px,7vw,84px);line-height:1.05;letter-spacing:.04em;margin-bottom:8px">Hatenabase,Group.</div>
    <div style="font-size:12px;color:rgba(255,255,255,.55);letter-spacing:.18em;margin-bottom:48px">BACKOFFICE, REDESIGNED.</div>
    <div class="hb-group-grid">
      <a href="https://hatenabase.jp/" style="text-decoration:none;color:inherit;display:block;border:1px solid rgba(255,255,255,.22);padding:24px 26px">
        <div style="font-size:10px;letter-spacing:.22em;color:rgba(255,255,255,.55);margin-bottom:10px">HATENABASE INC.</div>
        <div style="font-weight:700;font-size:16px;margin-bottom:8px">はてなベース株式会社 ↗</div>
        <div style="font-size:12px;line-height:1.9;color:rgba(255,255,255,.7)">DX・会計・AIの3領域で「攻めのバックオフィス」を構築。</div>
      </a>
      <a href="https://tax.hatenabase.jp/tax-accountant" style="text-decoration:none;color:inherit;display:block;border:1px solid rgba(255,255,255,.22);padding:24px 26px">
        <div style="font-size:10px;letter-spacing:.22em;color:rgba(255,255,255,.55);margin-bottom:10px">HATENABASE TAX OFFICE</div>
        <div style="font-weight:700;font-size:16px;margin-bottom:8px">はてなベース税理士法人 ↗</div>
        <div style="font-size:12px;line-height:1.9;color:rgba(255,255,255,.7)">クラウド会計を活用した税務顧問・融資支援・管理会計。</div>
      </a>
      <div style="border:1px solid rgba(255,255,255,.22);padding:24px 26px">
        <div style="font-size:10px;letter-spacing:.22em;color:rgba(255,255,255,.55);margin-bottom:10px">HATENABASE LABOR OFFICE</div>
        <div style="font-weight:700;font-size:16px;margin-bottom:8px">はてなベース社会保険労務士事務所</div>
        <div style="font-size:12px;line-height:1.9;color:rgba(255,255,255,.7)">労務・人事・社会保険関連業務を専門にサポート。</div>
      </div>
    </div>
    <div style="display:flex;flex-wrap:wrap;justify-content:space-between;align-items:center;gap:16px;border-top:1px solid rgba(255,255,255,.2);margin-top:56px;padding:22px 0 26px;font-size:12px;color:rgba(255,255,255,.65)">
      <div>Copyright &copy; {(y => y === 2025 ? '2025' : '2025–' + y)(new Date().getFullYear())} HatenaBase Inc.</div>
      <div style="display:flex;gap:24px">
        <a href="https://hatenabase.jp/" style="color:inherit;text-decoration:none">トップに戻る</a>
        <a href="https://hatenabase.jp/hatena-account/" style="color:inherit;text-decoration:none">会計事業部</a>
        <a href="https://hatenabase.jp/contact/" style="color:inherit;text-decoration:none">お問い合わせ</a>
      </div>
    </div>
  </div>
</section>
`.replace(/__ASSETS__/g, ASSETS);

  function HatenaContentPage() {
    React.useEffect(function(){
      var root = document.getElementById('hb-front-root') || document;
      var hdr  = root.querySelector('.hb-header');
      var burger = root.querySelector('.hb-mb-burger');
      var menu = null;

      // スクロール出現アニメ
      var obs = new IntersectionObserver(function(es){
        es.forEach(function(e){ if(e.isIntersecting) e.target.classList.add('is-in'); });
      }, { threshold:0.1 });
      root.querySelectorAll('.hb-up, .hb-chars').forEach(function(el){ obs.observe(el); });

      // ヘッダー背景（スクロール追従）
      function onScroll(){ if(hdr) hdr.style.background = window.scrollY>10 ? 'rgba(255,255,255,0.97)' : 'rgba(255,255,255,0.94)'; }
      window.addEventListener('scroll', onScroll, { passive:true }); onScroll();

      // モバイルメニュー
      function buildMenu(){
        if(menu) return menu;
        menu = document.createElement('div');
        menu.className = 'hb-academy-mbmenu';
        var links = [['#programs','研修ラインナップ'],['#flow','受講の流れ'],['#career','就労先'],['#pricing','料金'],['#faq','よくある質問']];
        menu.innerHTML = links.map(function(l){ return '<a href="'+l[0]+'">'+l[1]+'</a>'; }).join('')
          + '<a class="hb-academy-mbline" href="https://lin.ee/QnI7WzZ" target="_blank" rel="noopener">公式LINEに登録する →</a>';
        (hdr||root).appendChild(menu);
        return menu;
      }
      function closeMenu(){ if(menu) menu.classList.remove('is-open'); if(burger) burger.classList.remove('is-open'); }
      function toggleMenu(){ buildMenu(); menu.classList.toggle('is-open'); if(burger) burger.classList.toggle('is-open'); }
      if(burger) burger.addEventListener('click', toggleMenu);

      // アンカーのスムーススクロール
      function onClick(ev){
        var a = ev.target.closest && ev.target.closest('a[href^="#"]');
        if(!a) return;
        var id = a.getAttribute('href');
        if(id && id.length>1){ var t=document.querySelector(id); if(t){ ev.preventDefault(); t.scrollIntoView({behavior:'smooth', block:'start'}); closeMenu(); } }
      }
      root.addEventListener('click', onClick);

      return function(){
        window.removeEventListener('scroll', onScroll);
        root.removeEventListener('click', onClick);
        if(burger) burger.removeEventListener('click', toggleMenu);
        obs.disconnect();
      };
    }, []);

    return (
      <React.Fragment>
        <style dangerouslySetInnerHTML={{__html: CSS}}/>
        <div className="hb-academy-lp" dangerouslySetInnerHTML={{__html: HTML}}/>
      </React.Fragment>
    );
  }

  Object.assign(window, { HatenaContentPage });
})();
